import { PrintLogDialogComponent } from './../../../app-components/print-log-dialog/print-log-dialog.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { DialogService } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, ExportService, HelperService, HTTPService } from 'app/services';
import { GroupDatePickerDialogComponent } from 'app/modules/shared/components/group-date-picker-dialog/group-date-picker-dialog.component';
import { ExportReportDialogComponent } from '../export-report-dialog/export-report-dialog.component';
import { config, paymentTypeTitle } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import { sortBy, find, findIndex } from 'lodash';
import { Subscription } from 'rxjs';
import { printReportLabel } from 'app/constants/csv/constants';
import { ReportScheduleComponent } from 'app/modules/app-components';
import { title } from 'process';

@Component({
  selector: 'app-report-filter',
  templateUrl: './report-filter.component.html',
  styleUrls: ['./report-filter.component.scss'],
  providers: [DialogService],
})
export class ReportFilterComponent implements OnInit {
  @Input() exportedColumns?: any = {};
  @Input() drilldownItemType: string = '';
  @Input() options: any = {
    finalizeRevenue: false,
    statementBtn: true,
    singleDay: false,
    singleMonth: false,
    date: true,
    dateRang: true,
    customerType: true,
    supplierType: true,
    feeType: false,
    orderDiscountType: false,
    orderOn: false,
    itemType: true,
    tags: true,
    tech: true,
    salesGroup: false,
    salesCode: false,

    category: false,
    workflow: false,
    taxCode: false,
    archives: false,
    aging: false,
    payment: false,
    activity: false,
    paymentStatus: false,
    creditMemo: false,
    itemPaymentStatus: false,
    orderStatus: false,
    roStatus: true,
    lastSold: false,
    ratings: false,
    statementStatus: false,
    qboStatus: false,
    paymentType: false,
    paymentSubType: false,
    items: false,
    qtyType: false,
    sendStatus: false,
    paidStatus: false,
    location: false,
    multiTaxCode: false,
    serviceWriter: true,
    paymentGroup: false,
    companyName: false,
    supplier: false,
    taxItemType: true,
    itemCategory: false,
    customerFleet: false,
    paymentTerms: false,
    orderingStatus: false,
    orderingMethods: false,
    roType: false,
    genericFilter: false,
    orderStatusTechSummary: false,
    warrantyType: false,
  };
  @Input() genericFilterOptions: any = {
    iconClass: '',
    nameField: 'name',
    selectAllText: 'All',
    multipleSelectText: '',
    styleCss: {},
    filterOverlayStyle: {},
  };
  @Input() genericFilterData: any[] = [];
  serviceWriterId: string;
  selectedServiceWriter: any;
  @Input('preAppliedFilter')
  set setPreAppliedFilter(filter: any) {
    if (!filter) return;
    this.filter = filter;
    if (this.isRerunGenericFilterOnChange && this.filter.genericFilter && this.filter.genericFilter.selected && this.filter.genericFilter.selected.length) {
      this.onSelectGenericFilter(this.filter.genericFilter.selected);
    }
    if (filter.orderOn) {
      this.filter.orderOn = filter.orderOn;
      this.whichFilterApplied('orderOn');
    }

    if (filter.tech) {
      this.filter.tech = filter.tech;
      this.whichFilterApplied('tech');
    }

    if (filter.salesGroup) {
      this.filter.salesGroup = filter.salesGroup;
      this.whichFilterApplied('salesGroup');
    }

    if (filter.salesCode) {
      this.filter.salesCode = filter.salesCode;
      this.whichFilterApplied('salesCode');
    }

    if (filter.paymentStatus) {
      this.filter.paymentStatus = filter.paymentStatus;
      this.filterTitle.paymentStatus = filter.paymentStatus?.name;
      this.whichFilterApplied('paymentStatus');
    }

    if (this.filter && this.filter.date && this.filter.date.filterTitle && this.filter.date.endDate && !filter.generateDateTitle) {
      this.filterTitle.date = this.filter.date.filterTitle;
      this.filterApplied['date'] = true;
      this.updateDateRangeTitle();
      this.updatePaidStatuFilter();
    } else if (this.filter && this.filter.date && this.filter.date.filterTitle && this.filter.date.endDate && this.filter.isUpdateUrl) {
      this.filterTitle.date = this.filter.date.filterTitle;
      this.filterApplied['date'] = true;
      this.updateDateRangeTitle();
    }
  }
  @Input() formatFilterState: any = {};
  @Input() data: any = {};
  @Input() tagType: any = config.tags.customer;
  @Input() tagTitle: any = 'Customers tag';
  @Input() id: any = 'sales';
  @Input() heading: any = 'Sales';
  @Input() dateTitle: any = 'Today';
  @Input() path: string = '';
  @Input() toolTip: string = '';
  @Input() searchQuery: string = '';
  @Input() showDateNavigation: boolean = false;
  @Input() hasMultiLocationFilter: boolean = false;
  @Input() hasStatement: boolean = false;
  @Input() hasAccountStatement: boolean = false;
  @Input() updateUrl: boolean = true;
  @Input() hasExport: boolean = true;
  @Input() hasExportMidas: boolean = false;
  @Input() hasPrint: boolean = false;
  @Input() hasSchedule: boolean = false;
  @Input() taxCodes: any[] = [];
  @Input() baseTax: boolean = false;
  @Input() finalizeFilterBy: boolean = false;
  @Input() dateType: string = '';
  @Input() selectedSupplier: any = '';
  @Input() selectedTaxCode: any = '';
  @Input() isOnlinePayAvailable: boolean = false;
  @Input() source: boolean = false;
  @Input() reportType: string = '';
  @Input() isRevenueRecognitionSettleEnabled: boolean = false;
  @Input() isWriteOffEnable: boolean = false;
  @Input() dateRangeHoverInfo: string = '';
  @Input() preSelectedLocationsIds: any[] = [];
  @Input() hasOpenExportDialog: boolean = true;
  @Input() isRerunGenericFilterOnChange: boolean = false;
  @Input() notShowMobileView: boolean = false;
  @Input() defaultRoStatus: any = { estimate: false, invoice: false, finalized: false }; // ✅ Default input from parent

  @Output() filterChange = new EventEmitter<string>();
  @Output() onClearFilter = new EventEmitter<string>();

  momentPeriod = {
    day: 'days',
    week: 'weeks',
    month: 'months',
  };
  selectedDateTitle: string = '';
  closeAfterAction: boolean = false;
  hasAttendanceDate: boolean = false;

  tags: any[] = [];
  companyNames: any[] = [];
  items: any[] = [];
  locations: any[] = [];
  defalutTags: any[] = [];
  defalutItems: any[] = [];
  defalutLocations: any[] = [];
  technicians: any = [];
  defalutTechnicians: any = [];

  salesGroupsResults: any[] = [];
  defalutSalesGroup: any = [];

  salesCodeResults: any[] = [];
  defalutSalesCode: any[] = [];
  // pagination on sales group
  skipSalesGroup = 0;
  searchLimitSalesGroup = 8;
  hasMoreDataSalesGroup = true;

  // pagination on sales Code
  skipSalesCode = 0;
  searchLimitSalesCode = 8;
  hasMoreDataSalesCode = true;

  creditMemo: any = [];
  defaultCreditMemo: any = [];
  toggleExportDetails: boolean = false;

  serviceWriters: any = [];
  defalutServiceWriters: any = [];
  defaultCompanyNames: any = [];
  categories: any = [];
  defalutCategories: any = [];
  workFlowStatuses: any = [];
  defaultWorkFlowStatuses: any = [];
  agingOptions: any = [
    { id: '1-30 days', name: '1-30 days', isChecked: false },
    { id: '31-60 days', name: '31-60 days', isChecked: false },
    { id: '61-90 days', name: '61 to 90 days', isChecked: false },
    { id: '91 Days', name: '91+ days', isChecked: false },
  ];
  defaultAgingOptions: any = this.helperService.deepCopy(this.agingOptions);
  paymentStatusOptions: any = [
    { id: 'paid', name: 'Paid', isChecked: false },
    { id: 'unpaid', name: 'Unpaid', isChecked: false },
    { id: 'partially', name: 'Partially paid', isChecked: false },
  ];
  defaultPaymentStatusOptions: any = this.helperService.deepCopy(this.paymentStatusOptions);
  creditMemoOptions: any = [
    { id: 'issuancesOnly', name: 'Issuances Only', isChecked: false, tooltip: 'Reduce receivables by credit memo issuances' },
    { id: 'applicationOnly', name: 'Application Only', isChecked: true, tooltip: 'Reduce receivables by credit memo applications' },
  ];
  roStatus: any = [
    { id: 'estimate', name: 'Estimate', isChecked: true },
    { id: 'invoice', name: 'Invoiced', isChecked: true },
    { id: 'finalized', name: 'Finalized', isChecked: true },
  ];
  defaultRoStatusOptions: any = this.helperService.deepCopy(this.roStatus);
  defaultCreditMemoOptions: any = this.helperService.deepCopy(this.creditMemoOptions);
  lastSoldOptions: any = [
    { id: '30', name: 'Sold to in last 30 days', isChecked: false },
    { id: '61', name: 'Sold to between 61 - 90 days', isChecked: false },
    { id: '90', name: 'Sold before 90 days', isChecked: false },
    { id: '00', name: 'Never sold', isChecked: false },
  ];
  defalutLastSoldOptions: any = this.helperService.deepCopy(this.lastSoldOptions);
  ratingOptions: any = [
    { id: '5', name: '5 Star', isChecked: false },
    { id: '4', name: '4 Star', isChecked: false },
    { id: '3', name: '3 Star', isChecked: false },
    { id: '2', name: '2 Star', isChecked: false },
    { id: '1', name: '1 Star', isChecked: false },
  ];
  itemPaymentStatusOptions: any = [{ id: 'isPaidFull', name: 'Marked as paid', isChecked: false }];
  defaultItemPaymentStatusOptions: any = this.helperService.deepCopy(this.itemPaymentStatusOptions);
  statmentOptions: any = [
    { id: 'NON_STATEMENT', name: 'Non-statement Invoices', isChecked: false },
    { id: 'ALL', name: 'All Invoices', isChecked: false },
  ];
  defalutRatingOptions: any = this.helperService.deepCopy(this.ratingOptions);
  defalutStatementOptions: any = this.helperService.deepCopy(this.statmentOptions);
  selectedTechnicians: any = null;

  selectedCreditMemo: any = null;
  payableStatusList: any = [
    { id: 0, name: 'Due today', isChecked: false },
    { id: 1, name: 'Due Soon', isChecked: false },
    { id: -1, name: 'Overdue', isChecked: false },
  ];
  defaultPayableStatus: any = this.helperService.deepCopy(this.payableStatusList);

  itemTypeInventoryNonInventory: any[] = [
    { label: 'Part non-stock', value: 'Part (non-stock)', isChecked: false },
    { label: 'Tire non-stock', value: 'Tire (non-stock)', isChecked: false },
    { label: 'Part stock', value: 'Part (stock)', isChecked: false },
    { label: 'Tire stock', value: 'Tire (stock)', isChecked: false },
    { label: 'Shop supplies', value: 'Shop Supplies', isChecked: false },
  ];
  defaultItemTypeInventoryNonInventory: any = this.helperService.deepCopy(this.itemTypeInventoryNonInventory);

  orderTypeList: any = [
    { id: 'purchaseOrder', name: 'Purchase order', isChecked: false },
    { id: 'roPartsOrder', name: 'RO parts order', isChecked: false },
  ];
  defaultOrderTypeList: any = this.helperService.deepCopy(this.orderTypeList);
  activityTypeList: any = [
    { id: 'itemDelivered', name: 'Item Delivered', isChecked: false },
    { id: 'payment', name: 'Payment', isChecked: false },
    { id: 'coreReturn', name: 'Core Return', isChecked: false },
    { id: 'itemReturn', name: 'Item Return', isChecked: false },
  ];
  defaultActivityTypeList: any = this.helperService.deepCopy(this.activityTypeList);
  orderStatusForAllServices: any = [
    { id: 'paid', name: 'Paid', isChecked: false },
    { id: 'invoice', name: 'Invoice', isChecked: false },
    { id: 'partiallyPaid', name: 'Partially Paid', isChecked: false },
  ];
  defaultOrderStatusForAllServices: any = this.helperService.deepCopy(this.orderStatusForAllServices);
  filterApplied: any = {
    singleDay: false,
    singleMonth: false,
    date: 'last-week',
    tags: false,
    payableStatus: false,
    itemTypeInventoryNonInventory: false,
    orderType: false,
    tech: false,
    salesGroup: false,
    salesCode: false,
    customerType: false,
    supplierType: false,
    feeType: false,
    orderDiscountType: false,
    orderOn: false,
    itemType: false,
    activity: false,
    category: false,
    workflow: false,
    taxCode: false,
    archives: false,
    aging: false,
    payment: false,
    orderStatus: false,
    roStatus: false,
    qboStatus: false,
    paymentType: false,
    paymentSubType: false,
    paymentStatus: false,
    creditMemo: false,
    itemPaymentStatus: false,
    lastSold: false,
    rating: false,
    statementStatus: false,
    qtyType: false,
    sendStatus: false,
    paidStatus: false,
    items: false,
    location: false,
    multiTaxCode: false,
    serviceWriter: false,
    paymentGroup: false,
    companyName: false,
    supplier: false,
    taxItemType: false,
    itemCategory: false,
    customerFleet: false,
    paymentTerms: false,
    orderingStatus: false,
    orderingMethods: false,
    genericFilter: false,
    orderStatusTechSummary: false,
    activityType: false,
    warrantyType: false,
  };
  filterTitle = {
    creditMemo: 'Credit Memo',
    date: 'This week',
    category: 'Category',
    singleDay: {
      mon: 'Today',
      yesterday: 'Yesterday',
      customEnd: 'Custom Date',
    },
    singleMonth: {
      month: 'This month',
      lastMonth: 'Last month',
      customMonthEnd: 'Custom',
    },
    customerType: {
      all: 'All customers',
      newCustomers: '1st time invoiced customers',
      repeatCustomers: 'Repeat customers',
    },
    supplierType: {
      all: 'All supplier Types',
      internal: 'Internal',
      online: 'Online ordering',
    },
    feeType: {
      all: 'Fee type',
      serviceLevel: 'Service Level',
      roLevel: 'Ro Level',
      passThroughTax: 'Passthrough Tax',
    },
    orderOn: {
      all: 'Applied on',
      serviceLevel: 'Service Level',
      orderLevel: 'RO Level',
    },
    orderDiscountType: {
      all: 'Discount type',
      percentage: 'Percentage',
      dollarValue: 'Dollar Value',
    },
    itemType: {
      all: 'Item Type',
      // all: 'All item Types',
      part: 'Part',
      tire: 'Tire',
      labor: 'Labor',
      sublet: 'Sublet',
      tireStorage: 'Tire storage',
      other: 'Other',
    },
    warrantyType: {
      all: 'Warranty Type',
      first: 'First-time installation',
      replacement: 'Warranty replacement',
    },
    customerFleet: {
      all: 'Type',
      fleet: 'Fleet',
      regular: 'Regular',
    },
    sendStatus: {
      all: 'Sent status',
      sent: 'Sent',
      notSent: 'Not sent',
      sentMultipleTime: 'Sent Multiple Time',
    },
    paidStatus: {
      all: 'Payment status',
      unPaid: 'Unpaid ',
      partiallyPaid: 'Partially paid ',
      paid: 'Paid ',
    },
    qtyType: {
      // all other constants
      all: 'Qty type',
      ordered: 'Ordered',
      onHand: 'On hand',
      available: 'Available',
      onEstimates: 'On Estimate',
      multiple: 'Multiple tags',
    },
    activity: {
      all: 'Activity Type',
      inspections: 'Inspections',
      services: 'Services',
    },
    tags: {
      all: '',
      multiple: 'Multiple tags',
    },
    payableStatus: {
      all: '',
      multiple: 'Multiple Status',
    },
    itemTypeInventoryNonInventory: {
      all: '',
      multiple: 'Multiple',
    },
    items: {
      all: 'Items',
      multiple: 'Multiple items',
    },
    location: {
      all: 'Locations',
      multiple: 'Multiple locations',
    },

    multiTaxCode: {
      all: 'Tax code',
      multiple: 'Multiple Tax code',
    },
    tech: {
      all: 'Technicians',
      multiple: 'Multiple techs',
    },
    salesGroup: {
      all: 'Sales group',
      multiple: 'Multiple sales group',
    },
    salesCode: {
      all: 'Sales code',
      multiple: 'Multiple sales code',
    },
    serviceWriter: {
      all: 'Service advisor',
      multiple: 'Multiple service advisor',
    },
    workflow: 'Workflow',
    taxCode: 'Tax Code',
    archives: {
      all: 'Archives',
      archived: 'Archived',
      unArchived: 'Active',
    },
    paymentGroup: {
      all: 'Payment group',
      refund: 'Refund',
      void: 'Void',
      payment: 'Payment',
    },
    aging: 'Aging',
    paymentStatus: 'Payment',
    itemPaymentStatus: 'Payment status',
    companyName: {
      all: 'Company',
      multiple: 'Multiple companies',
    },
    supplier: {
      all: 'Supplier',
      multiple: 'Multiple suppliers',
    },
    taxItemType: {
      all: 'Item type',
      multiple: 'Multiple type',
    },
    itemCategory: {
      all: 'Item Category',
      multiple: 'Multiple itemCategorys',
    },
    lastSold: 'Last sold',
    rating: 'Ratings',
    statementTitle: 'Statement',
    payment: {
      all: 'All',
      unpaid: 'Unpaid',
      partiallyPaid: 'Partially paid',
      paid: 'Paid',
    },
    orderStatus: {
      all: 'Order Status',
      estimate: 'Estimate',
      invoice: 'Invoice',
      finalized: 'Finalized',
    },
    roStatus: {
      all: 'RO Status',
      multiple: 'Multiple Status',
      estimate: 'Estimate',
      invoice: 'Invoiced',
      finalized: 'Finalized',
    },
    qboStatus: {
      synced: 'Synced',
      notSynced: 'Out of Synced',
      notPosted: 'Not posted',
    },
    paymentType: paymentTypeTitle,
    orderingStatus: {
      unordered: 'Unordered',
      ordered: 'Ordered',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    paymentTerms: {
      payable: 'Payable',
      cod: 'COD',
    },
    orderingMethods: {
      online: 'Online',
      offline: 'Offline',
      provisional: 'Provisional',
      inventory: 'Inventory',
    },
    orderStatusTechSummary: {
      all: 'Order Status',
      multiple: 'Multiple Status',
    },
  };
  filter: any = {
    isFilterByFinalizeDate: false,
    singleDay: {
      today: null,
      yesterday: null,
      customEnd: null,
    },
    singleMonth: {
      month: null,
      lastMonth: null,
      customMonthEnd: null,
    },
    date: {
      startDate: null,
      endDate: null,
      filterTitle: '',
    },
    customerType: {
      newCustomers: false,
      repeatCustomers: false,
    },
    supplierType: {
      internal: false,
      online: false,
    },
    feeType: {
      serviceLevel: true,
      roLevel: true,
      passThroughTax: false,
    },
    orderOn: {
      orderLevel: false,
      serviceLevel: false,
    },
    orderDiscountType: {
      percentage: false,
      dollarValue: false,
    },
    itemType: {
      tire: false,
      part: false,
      labor: false,
      sublet: false,
      tireStorage: false,
      other: false,
    },
    warrantyType: {
      first: false,
      replacement: false,
    },
    customerFleet: {
      fleet: false,
      regular: false,
    },
    qtyType: {
      ordered: false,
      onHand: false,
      available: false,
      onEstimates: false,
    },
    sendStatus: {
      sent: false,
      notSent: false,
      sentMultipleTime: false,
    },
    paidStatus: {
      unPaid: false,
      partiallyPaid: false,
      paid: false,
    },
    activity: {
      inspections: false,
      services: false,
    },
    tags: {
      selected: [],
    },
    payableStatus: {
      selected: [],
    },
    itemTypeInventoryNonInventory: {
      selected: [],
    },
    orderType: {
      selected: [],
    },
    items: {
      selected: [],
    },
    location: {
      selected: [],
    },
    multiTaxCode: {
      selected: [],
    },
    activityType: {
      selected: [],
    },
    tech: null,
    salesGroup: null,
    salesCode: null,
    category: null,
    workflow: null,
    taxCode: null,
    archives: {
      archived: false,
      unArchived: false,
    },
    paymentGroup: {
      refund: false,
      void: false,
      payment: false,
    },
    aging: null,
    paymentStatus: null,
    creditMemo: {
      issuancesOnly: false,
      applicationOnly: true,
    },
    itemPaymentStatus: null,
    companyName: {
      selected: [],
    },
    supplier: {
      selected: [],
    },
    taxItemType: {
      selected: [],
    },
    itemCategory: {
      selected: [],
    },
    lastSold: null,
    rating: null,
    statementStatus: null,
    payment: {
      paid: false,
      unpaid: false,
      partiallyPaid: false,
    },
    orderStatus: {
      estimate: false,
      invoice: false,
      finalized: false,
    },
    //Don not make it default true as it creates problem on the counts that are showing how many filters are applied
    roStatus: {
      estimate: false,
      invoice: false,
      finalized: false,
    },
    qboStatus: {
      synced: false,
      notSynced: false,
      notPosted: false,
    },
    paymentType: {
      cash: false,
      cardManual: false,
      cardOnline: false,
      card: false,
      cheque: false,
      cardSwipe: false,
      creditPayment: false,
    },
    paymentSubTypeFilterOption: [],
    shopIds: [],
    orderingMethods: {
      online: false,
      offline: false,
      provisional: false,
      inventory: false,
    },
    orderingStatus: {
      unordered: false,
      ordered: false,
      delivered: false,
      cancelled: false,
    },
    paymentTerms: {
      payable: false,
      cod: false,
    },
    genericFilter: {
      selected: [],
    },
    orderStatusTechSummary: null,
  };
  filterConst: any = {
    statementBtn: true,
    singleDay: true,
    singleMonth: true,
    date: true,
    dateRang: true,
    customerType: 'customerType',
    supplierType: 'supplierType',
    feeType: 'feeType',
    orderDiscountType: 'orderDiscountType',
    orderOn: 'orderOn',
    itemType: 'itemType',
    warrantyType: 'warrantyType',
    tags: 'tags',
    payableStatus: 'payableStatus',
    itemTypeInventoryNonInventory: 'itemTypeInventoryNonInventory',
    orderType: 'orderType',
    tech: 'tech',
    salesGroup: 'salesGroup',
    salesCode: 'salesCode',
    category: 'category',
    workflow: 'workflow',
    taxCode: 'taxCode',
    archives: 'archives',
    aging: 'aging',
    payment: 'payment',
    activity: 'activity',
    paymentStatus: 'paymentStatus',
    itemPaymentStatus: 'itemPaymentStatus',
    orderStatus: 'orderStatus',
    roStatus: 'roStatus',
    lastSold: 'lastSold',
    ratings: 'rating',
    statementStatus: 'statementStatus',
    qboStatus: 'qboStatus',
    paymentType: 'paymentType',
    paymentSubType: 'paymentSubType',
    items: 'items',
    qtyType: 'qtyType',
    sendStatus: 'sendStatus',
    paidStatus: 'paidStatus',
    location: 'location',
    serviceWriter: 'serviceWriter',
    paymentGroup: 'paymentGroup',
    companyName: 'companyName',
    supplier: 'supplier',
    taxItemType: 'taxItemType',
    itemCategory: 'itemCategory',
    customerFleet: 'customerFleet',
    paymentTerms: 'paymentTerms',
    orderingStatus: 'orderingStatus',
    orderingMethods: 'orderingMethods',
    orderStatusTechSummary: 'orderStatusTechSummary',
    activityType: 'activityType',
  };
  filterDrawer: any = false;
  isDisableDateFilter = false;
  dateFilterOption: any = [
    { id: 'today', title: 'Today' },
    { id: 'yesterday', title: 'Yesterday' },
    { id: 'this-week', title: 'This week' },
    { id: 'last-week', title: 'Last week' },
    { id: 'this-month', title: 'This month' },
    { id: 'last-month', title: 'Last month' },
    { id: 'year-to-date', title: 'Year to date' },
    { id: 'all-time', title: 'All time' },
    { id: 'custom', title: 'Custom' },
  ];
  singleDayFilterOption: any = [
    { id: 'today', title: 'Today' },
    { id: 'yesterday', title: 'Yesterday' },
    { id: 'customEnd', title: 'Custom Date' },
  ];
  singleMonthFilterOption: any = [
    { id: 'this-month', title: 'This month' },
    { id: 'last-month', title: 'Last month' },
    // { id: 'customMonthEnd', title: 'Custom' },
    { id: 'custom', title: 'Custom' },
  ];
  defaultFilter: any = this.helperService.deepCopy(this.filter);
  clearFilterOption: boolean = false;
  isMultiLocationEnabled: boolean = false;
  hasMultiLocationAccess: boolean = false;
  canSwitchLocation: boolean = false;
  dataServiceSubscription: Subscription;
  currentDateTime: any = 0;
  retainDate: any;
  startDate: any;
  endDate: any;
  paymentMethods: any[] = [];
  companyLocations: any = [];
  cashPaymentMethods: any[] = [];
  cardPaymentMethods: any[] = [];
  otherPaymentMethods: any[] = [];
  thirdPartyPaymentMethods: any[] = [];
  writeOffPaymentMethods: any[] = [];
  attendanceCols: any[] = [];
  attendanceDays: any[] = [];
  serviceWriterUsers: any[] = [];
  daysOfMonthMap: any = {};
  daysNameMap: any = {};
  suppliers: any = [];
  taxItemTypes: any = [];
  itemCategorys: any = [];
  supplierList: any = [];
  filterArrayCount: any = 0;
  taxCodeList: any = [];
  isDesktopView: boolean = true;
  tempRestAgingDate: any = {};
  isSubletTrackingEnabled: boolean = false;
  isPassThroughTaxEnable: boolean = false;
  isDisableScheduleBtn: boolean = false;
  isMidasEnabled: boolean = true;
  canFinalizedAdjustmentInvoices: boolean = true;
  itemType: any[] = [];
  isItemSoldReportEnhancement: boolean = false
  // Item type global
  drilldownItemTypeG: any[] = [];
  // isLoading: boolean = false;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public dateService: DateService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService,
    private exportService: ExportService,
    private calculationService: CalculationService,
    private dataService: DataService,
    private router: Router,
  ) { }

  async ngOnInit() {
    if (window.innerWidth < 1199) this.isDesktopView = false;
    this.preDefaultFilters();

    const { hasMultiLocationAccess } = this.helperService.getCompany();

    this.hasMultiLocationAccess = hasMultiLocationAccess;
    this.setFeatureFlagSettings();
    this.dataService.path = this.path;
    if (this.heading !== 'Cash drawer') {
      this.isMultiLocationEnabled = this.dataService.isMultiLocationEnabled;
    }

    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data?.key === 'company-appdata-updated') {
        this.setFeatureFlagSettings();
        this.getTaxItemType();
      }

      if (data?.key === 'tax-appdata-update') {
        if (!data.data.baseTax) {
          this.clearFilter('paidStatus');
        } else if (data.data.baseTax) {
          this.onChange('paidStatus', 'paid');
        }
      }

      if (data.type === 'passdata' && data.key === 'update-date-type') {
        this.dateType = data.data;
      }

      if (data.data === 'Items sold' && this.helperService.getCompany().isRevenueRecognitionSettleEnabled) {
        this.filter.isFilterByFinalizeDate = true;
      }
    });

    if (this.hasStatement) {
      this.dateFilterOption = [
        { id: 'this-month', title: 'This month' },
        { id: 'last-month', title: 'Last month' },
        { id: 'year-to-date', title: 'Year to date' },
        { id: 'all-time', title: 'All time' },
        { id: 'custom', title: 'Custom' },
      ];
    }

    if (this.showDateNavigation) {
      this.dateFilterOption = [
        { id: 'today', title: 'Today' },
        { id: 'yesterday', title: 'Yesterday' },
        { id: 'this-week', title: 'This week' },
        { id: 'last-week', title: 'Last week' },
        { id: 'this-month', title: 'This month' },
        { id: 'last-month', title: 'Last month' },
        { id: 'custom', title: 'Custom' },
      ];
    }

    this.filterTitle.tags.all = this.tagTitle;
    console.log(this.options);
    if (this.options.salesGroup) {
      this.getSalesGroup();
    }

    if (this.options.salesCode) {
      this.getSalesCode();
    }

    if (this.options.tags) {
      this.getTags(this.tagType);
    }

    if (this.options.companyName) {
      this.getCompanyNames();
    }

    if (this.options.supplier) {
      this.getSupplier();
    }

    if (this.options.multiTaxCode) {
      this.getMultiTaxCode();
    }

    if (this.options.taxItemType) {
      this.getTaxItemType();
    }

    if (this.options.itemCategory) {
      this.getItemCategory();
    }

    if (this.options.items) {
      this.getItems();
    }

    if (this.options.location) {
      this.getLocations();
    }

    if (this.options.category) {
      this.getCategoryList();
    }

    if (this.options.workflow) {
      this.getWorkflowTags();
    }

    if (this.options.paymentSubType) {
      this.fetchPaymentMethods();
    }

    if (this.hasMultiLocationAccess && this.hasSchedule) {
      this.getCompanyLocation();
    } else {
      if (this.isMultiLocationEnabled) {
        this.isDisableScheduleBtn = true;
      }
    }

    if (this.dataService.taxCode) {
      this.filter.taxCode = this.dataService.taxCode;
      this.filterTitle.taxCode = this.dataService.taxCode && this.dataService.taxCode.name;
    }

    if (this.options.statementStatus) {
      this.onSelectStatemnet({
        id: 'NON_STATEMENT',
        name: 'Non-statement Invoices',
        isChecked: true,
      });
    }
    this.currentDateTime = await this.httpService.getServerTime();

    if (!['/reports/google-review', '/reports/acc-payable-supplier', '/reports/orderarbycustomer', '/reports/technician-attendance-log-details', 'create-bulk-statement'].includes(this.path)) {
      // Saving selected date to local-storage
      this.retainDate = JSON.parse(localStorage.getItem('retain-date'));
      this.serviceWriterId = this.activatedRoute.snapshot.paramMap.get('service-writer') || '';
      if (this.retainDate && this.retainDate.startDate && this.retainDate.endDate) {
        const { startDate, endDate, filterTitle, id } = this.retainDate;
        this.startDate = startDate;
        this.endDate = endDate;
        this.selectedDateTitle = filterTitle;
      } else {
        this.startDate = this.activatedRoute.snapshot.paramMap.get('start');
        this.endDate = this.activatedRoute.snapshot.paramMap.get('end');
        this.selectedDateTitle = this.activatedRoute.snapshot.paramMap.get('date-title');
      }
    } else {
      this.startDate = this.activatedRoute.snapshot.paramMap.get('start');
      this.endDate = this.activatedRoute.snapshot.paramMap.get('end');
      this.selectedDateTitle = this.activatedRoute.snapshot.paramMap.get('date-title');
    }

    const start = this.startDate;
    const end = this.endDate;
    const id = this.activatedRoute.snapshot.paramMap.get('id');

    this.filter.title = id || '';
    const isSingleDay: any = start == end;

    // if filter being used in attendance log
    // if (this.id === 'royalty') {
    //   // this.setDateForRoyaltyReportSingleMonth();
    //   // return;
    // } else 

    if (this.id === 'technician-attendance-log') {
      //All the time filter is not applicable on attendance log report as the showDateNavigation is set to true. ALP-20589
      if (this.retainDate && this.retainDate.startDate && this.retainDate.endDate && this.retainDate?.id !== 'all-time') {
        const { startDate, endDate, filterTitle, id } = this.retainDate;

        this.filter.date.startDate = this.dateService.formatDate(`${startDate} 00:00`, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(`${endDate} 23:59`, datetimeFormat.yyymmdd);

        const startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
        const endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);

        this.dateTitle = this.retainDate?.dateTitle || this.dateService.formatDateRange(startDateTime, endDateTime);
        this.filterTitle.date = filterTitle;
        this.filter.date.filterTitle = filterTitle;
        this.onDateSelect(this.retainDate?.filterTitle);
      } else {
        const datetime: Date = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

        const firstDay: Date = new Date(datetime.getFullYear(), datetime.getMonth(), 1);
        const lastDay: Date = new Date(datetime.getFullYear(), datetime.getMonth() + 1, 0);

        this.filter.date.startDate = this.dateService.formatDate(firstDay, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(lastDay, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDate(firstDay, datetimeFormat.mmmyyyy);
        this.filterTitle.date = 'This Month';
        this.filter.date.filterTitle = 'This Month';
        this.onDateSelect('this-month');
      }
      this.filterChange.emit(this.filter);
      return;
    } else if (this.id === 'technician-attendance-log-details' && isSingleDay) {
      this.filter.date.startDate = this.dateService.formatDate(`${start}T00:00:00`, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(`${end}T00:00:00`, datetimeFormat.yyymmdd);

      const startDateFormatted = this.dateService.formatDate(`${start}T00:00:00`, datetimeFormat.yyymmdd);
      const todayDate = this.dateService.formatDate(this.currentDateTime, datetimeFormat.yyymmdd);

      if (startDateFormatted == todayDate) {
        this.onDateSelect('today');
        return;
      } else {
        this.onDateSelect('passed-day');
      }
      this.filterChange.emit(this.filter);
      return;
    } else if (this.id === 'orderArByCustomer-invoice') {
      if (this.filter.creditMemo) {
        this.onSelectCreditStatus(this.creditMemoOptions[1]);
      }
    }

    if (this.options && this.options.date && start && end && this.dateService.isValid(start) && this.dateService.isValid(end)) {
      if (!this.filter.date) this.filter.date = {};
      this.filter.date.startDate = this.dateService.formatDate(`${start}T00:00:00`, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(`${end}T00:00:00`, datetimeFormat.yyymmdd);

      const startDate = this.dateService.formatDate(`${start}T00:00:00`, datetimeFormat.mmmdyyyy);
      const endDate = this.dateService.formatDate(`${end}T00:00:00`, datetimeFormat.mmmdyyyy);

      this.dateTitle = this.dateService.formatDateRange(startDate, endDate);
      if (
        [
          '/reports/fee-report',
          '/reports/sold-report',
          '/reports/service-invoiced',
          '/reports/labor-reporting',
          '/reports/discount-reporting',
          '/reports/supplier-summary',
          // '/reports/drill-down-report',
          // '/reports/discount-drill-down-report',
          '/reports/end-day-cash-drawer',
          '/reports/sales-tax-item',
          '/reports/commission-summary',
        ].includes(this.path)
      ) {
        if (this.retainDate && this.retainDate.startDate && this.retainDate.endDate) {
          const { startDate, endDate, filterTitle, id } = this.retainDate;
          this.filterTitle.date = filterTitle;
          this.filter.date.filterTitle = filterTitle;
          if (id !== 'custom' && id !== 'customMonthEnd') {
            this.onDateSelect(id);
          }
        } else {
          this.filterTitle.date = 'This month';
          this.filter.date.filterTitle = 'This month';
          this.onDateSelect('this-month');
        }
      } else {
        if (this.selectedDateTitle) {
          switch (this.selectedDateTitle) {
            case 'Today':
              this.onDateSelect('today');
              break;
            case 'Yesterday':
              this.onDateSelect('yesterday');
              break;
            case 'This week':
              this.onDateSelect('this-week');
              break;
            case 'Last week':
              this.onDateSelect('last-week');
              break;
            case 'This month':
              this.onDateSelect('this-month');
              break;
            case 'Last month':
              this.onDateSelect('last-month');
              break;
            case 'Year to date':
              this.onDateSelect('year-to-date');
              break;
            case 'All time':
              this.onDateSelect('all-time');
              break;
            case 'Custom':
              // this.onDateSelect('custom');
              break;
            default:
              this.onDateSelect('last-week');
          }
          this.filterTitle.date = this.selectedDateTitle;
          this.filter.date.filterTitle = this.selectedDateTitle;
          this.filterApplied.date = this.retainDate?.id;
        } else {
          this.filterTitle.date = 'custom';
          this.filter.date.filterTitle = 'custom';
          this.filterApplied.date = this.retainDate?.id;
        }

        if (this.updateUrl) {
          if (this.path === '/reports/canned-service-detail' && this.filter.title) {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
          } else if (this.path === '/reports/fee-drill-down-report') {
            this.location.replaceState(`${this.path}/${this.data.type}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
            this.filterChange.emit(this.filter);
          } else if (this.path === '/reports/supplier-detail') {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
          } else if (this.path === '/reports/technician-summary-all-service-details') {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
          } else if (this.path === '/reports/technician-detail') {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
          } else if (this.path === '/reports/drill-down-report' || this.path === '/reports/enhance-item-sold-detail') {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}/${this.serviceWriterId}`);
          } else if (this.path === '/reports/tax-detail') {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
          } else {
            this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.filter.title}`);
          }
        }
      }

      // only emit if tech has no id to avoid an extra call that will be done in getAllTech
      if (!id) {
        this.filterChange.emit(this.filter);
      } else if (this.id === 'commission-drilldown') {
        this.filterChange.emit(this.filter);
      }
    } else if (!this.options.date) {
      if (this.path === '/reports/end-day-cash-drawer-details' && this.retainDate && this.retainDate.id) {
        this.onDateSelect(this.retainDate.id);
      } else {
        this.onDateSelect('all-time');
      }
    } else {
      if (this.hasStatement && !this.hasAccountStatement) {
        if (this.options.redirectToStatementTab) {
          this.onDateSelect('all-time');
        } else {
          this.onDateSelect('this-month');
        }
      } else if (this.hasAccountStatement) {
        this.filter.paidStatus.partiallyPaid = true;
        this.filter.paidStatus.unPaid = true;
        this.onDateSelect('all-time');
      } else {
        if (
          [
            '/reports/supplier-summary',
            '/reports/service-invoiced',
            '/reports/sold-report',
            '/reports/fee-report',
            // '/reports/discount-drill-down-report',
            '/reports/labor-reporting',
            '/reports/discount-reporting',
            '/reports/end-day-cash-drawer',
            '/reports/sales-tax-item',
            // '/reports/tax-detail',
            '/reports/commission-summary',
            '/reports/royalty',
          ].includes(this.path)
        ) {
          this.onDateSelect('this-month');
        } else if (this.path === '/reports/daily-report') {
          this.onDateSelect('today');
        } else {
          this.onDateSelect('this-week');
        }
      }
    }
    this.getDateFilterDisableForAR();
    const e = this.dataService;

    if ((e.isOnlinePaymentEnable && e.isPayrixConnected) || (e.isGlobalPayConnected && e.isGlobalPayEnabled) || (e.isGlobalPayConnected && e.isGlobalPaySwipeConnected)) {
      this.isOnlinePayAvailable = true;
    } else {
      this.isOnlinePayAvailable = false;
    }

    if (this.options.singleMonth) {
      this.options.date = false;
    }

  }

  handleExportDetailToggle() {
    this.toggleExportDetails = !this.toggleExportDetails;
  }

  // setDateForRoyaltyReportSingleMonth() {
  //   if (this.retainDate && this.retainDate.startDate && this.retainDate.endDate && ['last-month', 'this-month', 'custom'].includes(this.retainDate.id)) {
  //     this.filter.title = this.retainDate.id;
  //     if (this.retainDate.id === 'custom') {
  //       const { startDate, endDate } = this.retainDate;
  //       this.filter.date = { filterTitle: 'Custom', startDate, endDate };
  //       this.filterTitle.date = 'Custom';
  //       this.filter.date.filterTitle = 'Custom';
  //       this.dateTitle = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmyyyy);
  //     }
  //     if (this.retainDate.id !== 'custom') {
  //       this.onDateSelect(this.filter.title);
  //     }
  //     this.filterChange.emit(this.filter);
  //   } else {
  //     const datetime: Date = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

  //     const firstDay: Date = new Date(datetime.getFullYear(), datetime.getMonth(), 1);
  //     const lastDay: Date = new Date(datetime.getFullYear(), datetime.getMonth() + 1, 0);

  //     this.filter.date.startDate = this.dateService.formatDate(firstDay, datetimeFormat.yyymmdd);
  //     this.filter.date.endDate = this.dateService.formatDate(lastDay, datetimeFormat.yyymmdd);

  //     this.dateTitle = this.dateService.formatDate(firstDay, datetimeFormat.mmmyyyy);
  //     this.filterTitle.date = 'This Month';
  //     this.filter.date.filterTitle = 'This Month';
  //     this.onDateSelect('this-month');
  //     this.filterChange.emit(this.filter);
  //   }
  // }

  setFeatureFlagSettings() {
    const {
      canSwitchLocation,
      currentShopId,
      isMultiLocationEnabled,
      isCompanyLoading,
      isGlobalPayConnected,
      isGlobalPayEnabled,
      isOnlinePaymentEnable,
      isPayrixConnected,
      isGlobalPaySwipeConnected,
      isSubletTrackingEnabled,
      isPassThroughTaxEnable,
      canFinalizedAdjustmentInvoices,
      isItemSoldReportEnhancement
    } = this.dataService;

    this.isMultiLocationEnabled = isMultiLocationEnabled;
    this.canSwitchLocation = canSwitchLocation;
    this.isPassThroughTaxEnable = isPassThroughTaxEnable;
    this.canFinalizedAdjustmentInvoices = canFinalizedAdjustmentInvoices;
    this.isItemSoldReportEnhancement = isItemSoldReportEnhancement;

    //Here we are fetching all employees if tech or serviceWrite enable
    const fetchGetAllEmployees = this.options.tech || this.options.serviceWriter;
    if (fetchGetAllEmployees && !this.technicians.length) {
      this.getAllEmployees(this.isMultiLocationEnabled);
    }

    if ((isOnlinePaymentEnable && isPayrixConnected) || (isGlobalPayConnected && isGlobalPayEnabled) || (isGlobalPayConnected && isGlobalPaySwipeConnected)) {
      this.isOnlinePayAvailable = true;
    } else {
      this.isOnlinePayAvailable = false;
    }

    if (!isCompanyLoading && isMultiLocationEnabled && !canSwitchLocation) {
      this.onMultiLocationChange([{ _id: currentShopId }]);
    }
    this.isSubletTrackingEnabled = isSubletTrackingEnabled;
  }

  getDateFilterDisableForAR() {
    if (
      (this.path === '/reports/orderarbycustomer' && this.filter.customerFleet.regular) ||
      (this.path === '/reports/orderarbycustomer' && !this.filter.customerFleet.regular && !this.filter.customerFleet.fleet)
    ) {
      this.isDisableDateFilter = true;
    } else this.isDisableDateFilter = false;
  }

  getTags(type: any) {
    this.httpService.getTags(type).then(
      (tags: any[]) => {
        if (tags.length) {
          tags.forEach((tag) => (tag['isChecked'] = false));
          this.tags = tags.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.defalutTags = this.helperService.deepCopy(this.tags);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  preDefaultFilters() {
    if (!this.filter.paidStatus) {
      this.filter.paidStatus = {};
    }

    this.filter.paidStatus.partiallyPaid = this.options.redirectToStatementTab;
    this.filter.paidStatus.unPaid = this.options.redirectToStatementTab;

    if (this.hasAccountStatement) {
      this.filter.paidStatus.partiallyPaid = true;
      this.filter.paidStatus.unPaid = true;
    }

    if (this.dataService.paidStatus) {
      this.filter.paidStatus = this.dataService.paidStatus;
    }

    if (this.dataService.discountType) {
      this.filter.orderDiscountType = this.dataService.discountType;
    }

    if (this.heading === 'Tax summary') {
      this.filter.orderStatus = {
        estimate: false,
        invoice: true,
      };
    }

    // ✅ Apply default values only if `roStatus` is missing or all false
    if (!this.filter.roStatus || Object.values(this.filter.roStatus).every(val => val === false)) {
      this.filter.roStatus = { ...this.defaultRoStatus };

      this.resetFilters()
    }
  }

  getCompanyNames() {
    this.httpService.getCustomerCompanyNames().then(
      (tags: any[]) => {
        if (tags.length) {
          tags.forEach((tag) => (tag['isChecked'] = false));
          this.companyNames = tags.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.defaultCompanyNames = this.helperService.deepCopy(this.companyNames);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getSupplier() {
    this.httpService
      .getSuppliers(true)
      .then(
        (suppliers: any) => {
          suppliers = suppliers.records;
          suppliers.push({ _id: 'unknown', name: 'Unknown supplier', isChecked: false });
          this.suppliers = suppliers.map(({ _id, name, isChecked }) => ({
            id: _id,
            name: name,
            isChecked: false,
          }));
          if (this.selectedSupplier !== '') {
            this.suppliers.filter((supplier) => {
              if (supplier.id === this.selectedSupplier) {
                setTimeout(() => {
                  supplier.isChecked = true;
                  this.filter.supplier.selected = [supplier];
                  this.closeAfterAction = !this.closeAfterAction;
                  this.whichFilterApplied();
                  this.filterChange.emit(this.filter);
                }, 100);
              }
            });
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .catch((error) => this.helperService.showToaster('error', error))
      .finally(() => { });
  }

  getTaxItemType() {
    const taxItemTypes = [
      { name: 'Part', _id: 'part', isChecked: false },
      { name: 'Labor', _id: 'labor', isChecked: false },
      { name: 'RO level fee', _id: 'roLevelFee', isChecked: false },
      { name: 'Tire', _id: 'tire', isChecked: false },
      { name: 'Other', _id: 'other', isChecked: false },
      { name: 'Discount', _id: 'discount', isChecked: false },
      { name: 'Fee', _id: 'hazmatFee', isChecked: false },
      { name: 'Tire Storage', _id: 'tireStorage', isChecked: false },
    ];

    if (this.isSubletTrackingEnabled) {
      if (!find(taxItemTypes, { _id: 'sublet' })) {
        taxItemTypes.splice(findIndex(taxItemTypes, { _id: 'tire' }) + 1, 0, { name: 'Sublet', _id: 'sublet', isChecked: false });
      }
    }
    if (this.isPassThroughTaxEnable) {
      taxItemTypes.push({ name: 'Passthrough Tax', _id: 'passThroughTax', isChecked: false });
    }

    this.taxItemTypes = taxItemTypes.map(({ _id, name, isChecked }) => ({
      id: _id,
      name: name,
      isChecked: false,
    }));
    if (this.selectedTaxCode !== '') {
      this.taxItemTypes.filter((item) => {
        if (item.id === this.selectedTaxCode) {
          this.onSelectItemTaxTypeName(item);
          item.isChecked = true;
          this.filter.taxItemType.selected = [item];
          this.closeAfterAction = !this.closeAfterAction;
          this.whichFilterApplied();
          this.filterChange.emit(this.filter);
        }
      });
    }
  }

  getMultiTaxCode() {
    if (this.filter.taxCodes) {
      this.taxCodeList = this.filter.taxCodes;
    } else {
      this.httpService.getTaxesData().then(
        (data: any) => {
          const { taxCodes, taxRates } = data;
          this.taxCodeList = taxCodes;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }

    if (this.taxCodeList && this.taxCodeList.length) {
      this.taxCodeList = this.taxCodeList.map(({ _id, name, isChecked }) => ({
        id: _id,
        name: name,
        isChecked: false,
      }));

      this.taxCodeList.filter((item) => {
        if (this.filter.taxCode && item.id === this.filter.taxCode._id) {
          item.isChecked = true;
          this.filter.multiTaxCode.selected = [item];
          this.closeAfterAction = !this.closeAfterAction;
          this.whichFilterApplied();
          this.filterChange.emit(this.filter);
        }
      });
    }
  }

  getItemCategory() {
    this.httpService
      .getItemCategorys()
      .then(
        (itemCategorys: any) => {
          this.itemCategorys = itemCategorys;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .catch((error) => this.helperService.showToaster('error', error))
      .finally(() => { });
  }

  /**
   * Get stock items
   */
  getItems(searchString?: string): void {
    this.httpService
      .getStocks({
        search: searchString,
        sortField: 'title',
        sortOrder: 1,
        limit: 100,
        skip: 0,
      })
      .then((items: any) => {
        if (items.records && items.records.length) {
          items.records.forEach((item) => {
            item['isChecked'] = false;
            item.name = item.title;
            return item;
          });
          this.items = items.records.sort((a, b) => (a.title > b.title ? 1 : -1));
          this.defalutItems = this.helperService.deepCopy(this.items);
        }
      })
      .catch((error) => this.helperService.showToaster('error', error));
  }

  /**
   * Get locations
   */
  getLocations(searchString?: string): void {
    this.httpService
      .getLocation()
      .then((locations: any) => {
        if (locations.records && locations.records.length) {
          locations.records.forEach((item) => {
            item['isChecked'] = false;
            item.name = item.title;
            return item;
          });
          this.locations = locations.records.sort((a, b) => (a.title > b.title ? 1 : -1));
          this.defalutLocations = this.helperService.deepCopy(this.locations);
        }
      })
      .catch((error) => this.helperService.showToaster('error', error));
  }

  getAllEmployees(isMLEmployees = false) {
    let payload: any = {}
    if (isMLEmployees) payload.employeList = true;
    this.httpService.getAllEmployees(payload).then(
      (result) => {
        this.technicians = [];
        const technicians = this.helperService.deepCopy(result);
        this.serviceWriterUsers = [];
        technicians.forEach((tech: any) => {
          const user = {
            id: tech._id,
            name: `${tech.firstName} ${tech.lastName}`,
            value: tech,
            isInActive: tech.isInActive,
            isChecked:
              tech._id === this.activatedRoute.snapshot.paramMap.get('id')
                ? (() => {
                  this.filter.tech = {
                    id: tech._id,
                    name: `${tech.firstName} ${tech.lastName}`,
                  };
                  this.whichFilterApplied();
                  this.filterChange.emit(this.filter);
                  return true;
                })()
                : false,
          };

          if (tech.role === 'tech' || tech.isWorkAsTechEnabled) {
            this.technicians.push(user);
          }
          if (tech.role === ' ' || tech.role === 'admin' || tech.role === 'serviceWriter') {
            this.serviceWriterUsers.push(user);
          }
        });

        this.defalutServiceWriters = this.helperService.deepCopy(this.serviceWriterUsers);
        this.defalutTechnicians = this.helperService.deepCopy(this.technicians);

        if (this.serviceWriterId) {
          this.selectedServiceWriter = this.defalutServiceWriters.filter((item) => item.id == this.serviceWriterId);
          if (this.selectedServiceWriter?.length) this.onSelectServiceWriter(this.selectedServiceWriter[0]);
        }
        this.technicians = this.sortActiveFirst(this.technicians);
        this.serviceWriterUsers = this.sortActiveFirst(this.serviceWriterUsers);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  onScrollGetSalesGroup() {
    this.skipSalesGroup += this.searchLimitSalesGroup;
    this.getSalesGroup();
  }

  async getSalesGroup() {
    try {
      if (!this.hasMoreDataSalesGroup) {
        return;
      }

      const conf = {
        // skip: this.skip,
        limit: this.searchLimitSalesGroup,
        page: Math.floor(this.skipSalesGroup / this.searchLimitSalesGroup),
        sortOrder: 1,
        // search: this.searchQuery,
      };

      const res: any = await this.httpService.getSearchTags('sales_group', conf);
      if (res[0] && res[0].records?.length) {
        const response = res[0].records;
        const filter = response.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.name === value.name
          ))
        );
        this.salesGroupsResults = [...this.salesGroupsResults, ...filter];
        if (response?.length < this.searchLimitSalesGroup) {
          this.hasMoreDataSalesGroup = false;
        }
      } else {
        this.hasMoreDataSalesGroup = false;
      }
      this.defalutSalesGroup = this.helperService.deepCopy(this.salesGroupsResults);
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    }
  }

  onScrollGetSalesCode() {
    this.skipSalesCode += this.searchLimitSalesCode;
    this.getSalesCode();
  }

  async getSalesCode() {
    try {
      if (!this.hasMoreDataSalesCode) {
        return;
      }

      const conf = {
        limit: this.searchLimitSalesCode,
        page: Math.floor(this.skipSalesCode / this.searchLimitSalesCode),
        sortOrder: 1,
        codeType: 'salesCode'
      };

      const res: any = await this.httpService.getSalesCodeList(conf);
      if (res[0] && res[0].records?.length) {
        const response = res[0].records;
        this.salesCodeResults = [...this.salesCodeResults, ...response];
        if (response?.length < this.searchLimitSalesCode) {
          this.hasMoreDataSalesCode = false;
        }
      } else {
        this.hasMoreDataSalesCode = false;
      }
      this.defalutSalesCode = this.helperService.deepCopy(this.salesCodeResults);

    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    }
  }

  sortActiveFirst(users: any[]) {
    const active = users.filter((user) => !user.isInActive).sort((a, b) => a.name.localeCompare(b.name));
    const inactive = users.filter((user) => user.isInActive).sort((a, b) => a.name.localeCompare(b.name));
    return [...active, ...inactive];
  }

  sortUsers() {
    this.technicians = this.sortActiveFirst(this.technicians);
    this.serviceWriterUsers = this.sortActiveFirst(this.serviceWriterUsers);
  }

  // getAllServiceWriter() {
  //   this.httpService.getAllEmployees().then(
  //     (result) => {
  //       this.serviceWriters = result.map((tech) => ({
  //         id: tech._id,
  //         name: `${tech.firstName} ${tech.lastName}`,
  //         value: tech,
  //         isChecked:
  //           tech._id === this.activatedRoute.snapshot.paramMap.get('id')
  //             ? (() => {
  //                 this.filter.serviceWriter = {
  //                   id: tech.serviceWriterId,
  //                   name: tech.name,
  //                 };
  //                 this.whichFilterApplied();
  //                 this.filterChange.emit(this.filter);
  //                 return true;
  //               })()
  //             : false,
  //       }));
  //       this.defalutServiceWriters = this.helperService.deepCopy(this.serviceWriters);
  //     },
  //     (error) => {
  //       this.helperService.showToaster('error', error);
  //     }
  //   );
  // }

  getCategoryList() {
    this.httpService.getTags(config.category.service).then(
      (categories: any[]) => {
        if (categories) {
          this.categories = categories.map(({ _id, name }) => ({
            id: _id,
            name: name,
          }));
          this.defalutCategories = this.helperService.deepCopy(this.categories);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getWorkflowTags() {
    this.httpService.getWorkbanFlow().then(
      (workflow: any[]) => {
        if (workflow.length) {
          const status = sortBy(workflow, 'order');
          this.workFlowStatuses = status.map((wStatus: any) => ({
            id: wStatus._id,
            name: wStatus.name,
            value: wStatus,
            isChecked: false,
          }));

          this.defaultWorkFlowStatuses = this.helperService.deepCopy(this.workFlowStatuses);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onSubTypeSelect(id: string) {
    let filterApplied = false;
    this.closeAfterAction = !this.closeAfterAction;
    this.filter.paymentSubTypeFilterOption = this.filter.paymentSubTypeFilterOption.map((rec) => {
      if (rec._id === id) {
        filterApplied = !rec.selected;
        rec.selected = !rec.selected;
      }
      return rec;
    });
    if (filterApplied) {
      this.filterApplied.paymentSubType = true;
    }
    this.filterApplied.paymentSubType = this.filter.paymentSubTypeFilterOption.map((p) => p.selected).includes(true);
    this.filterChange.emit(this.filter);
  }

  onChange(type: string, key: string) {
    if (type === 'isFilterByFinalizeDate') {
      if (key === 'true') {
        this.filter.isFilterByFinalizeDate = true;
      } else if (key === 'false') {
        this.filter.isFilterByFinalizeDate = false;
      }
      this.filterChange.emit(this.filter);
      return;
    }
    this.filter[type][key] = !this.filter[type][key];
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied(type);

    if (type === 'payment') {
      this.filterApplied.payment = this.filter.payment.unpaid || this.filter.payment.partiallyPaid;
    }
    if (type === 'customerType') {
      this.filterApplied.customerType = this.filter.customerType.newCustomers || this.filter.customerType.repeatCustomers;
    }
    if (type === 'customerFleet') {
      this.getDateFilterDisableForAR();
    }

    this.filterChange.emit(this.filter);
  }

  changeTagFilter(event: any) {
    this.filter.tags.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changePayableStatus(event: any) {
    this.filter.payableStatus.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changeItemTypeInventoryNonInventory(event: any) {
    this.filter.itemTypeInventoryNonInventory.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changeOrderType(event: any) {
    this.filter.orderType.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changeActivityType(event: any) {
    this.filter.activityType.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changeItemsFilter(event: any) {
    this.filter.items.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changeLocationsFilter(event: any) {
    this.filter.location.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  changeTaxcodeFilter(event: any) {
    this.filter.multiTaxCode.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectTechnician(event: any) {
    if (this.technicians.length === event.length) {
      this.filter.tech = null;
    } else {
      this.filter.tech = event;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectSalesGroup(event: any) {
    if (this.salesGroupsResults.length === event.length) {
      this.filter.salesGroup = null;
    } else {
      this.filter.salesGroup = event;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectSalesCode(event: any) {
    if (this.salesCodeResults.length === event.length) {
      this.filter.salesCode = null;
    } else {
      this.filter.salesCode = event;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectOrderStatusAllService(event: any) {
    if (this.orderStatusForAllServices.length === event.length) {
      this.filter.orderStatusTechSummary = null;
    } else {
      this.filter.orderStatusTechSummary = event;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectServiceWriter(event: any) {
    if (this.serviceWriters.length === event.length) {
      this.filter.serviceWriter = null;
    } else {
      this.filter.serviceWriter = event;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectLastSold(event: any) {
    if (this.lastSoldOptions.length === event.length) {
      this.filter.lastSold = null;
    } else {
      this.filter.lastSold = event;
    }

    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectStatemnet(event) {
    if (this.statmentOptions.length === event.length) {
      this.filter.statementStatus = null;
      this.filterTitle.statementTitle = 'Statement';
    } else {
      this.filter.statementStatus = event;
      this.filterTitle.statementTitle = event.name;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectRating(event) {
    if (this.ratingOptions.length === event.length) {
      this.filter.rating = null;
      this.filterTitle.rating = 'Ratings';
    } else {
      this.filter.rating = event;
      this.filterTitle.rating = event.name;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectWorkflow(event: any) {
    if (this.workFlowStatuses.length === event.length) {
      this.filter.workflow = null;
      this.filterTitle.workflow = 'Workflow';
    } else {
      this.filter.workflow = event;
      this.filterTitle.workflow = this.filter.workflow.name;
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onTaxCodeSelect(event: any) {
    if (this.taxCodeList && this.taxCodeList.length === event && event.length) {
      this.filter.taxCode = null;
      this.filterTitle.taxCode = 'Tax Code';
    } else {
      this.dataService.taxCode = event;
      this.filter.taxCode = event;
      this.filterTitle.taxCode = this.filter.taxCode && this.filter.taxCode.name;
    }

    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectCategory(event: any) {
    if (event && event.id) {
      this.filter.category = event;
      this.filterTitle.category = event.name;
    } else {
      this.filter.category = null;
      this.filterTitle.category = 'Category';
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  async onSelectAging(event) {
    const { id } = event;
    if (event && event.id) {
      this.filter.aging = event;
      this.filterTitle.aging = event.name;
    } else {
      this.filter.aging = null;
      this.filterTitle.aging = 'Aging';
    }

    this.whichFilterApplied();
    const currentDateTime = await this.httpService.getServerTime();

    let datetime: any = this.dateService.getCurrentDateTimeTz(Number(currentDateTime));

    if (!this.filter.date) this.filter.date = {};

    //  taken temp variables to use during clear aging filter
    this.tempRestAgingDate.startDate = this.filter.date.startDate;
    this.tempRestAgingDate.endDate = this.filter.date.endDate;

    if (id === '1-30 days') {
      this.filter.date.startDate = this.dateService.subDaysInDatetime(datetime, 30, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
    }

    if (id === '31-60 days') {
      this.filter.date.startDate = this.dateService.subDaysInDatetime(datetime, 60, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.subDaysInDatetime(datetime, 30, this.momentPeriod.day, datetimeFormat.yyymmdd);
    }

    if (id === '61-90 days') {
      this.filter.date.startDate = this.dateService.subDaysInDatetime(datetime, 90, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.subDaysInDatetime(datetime, 60, this.momentPeriod.day, datetimeFormat.yyymmdd);
    }

    if (id === '91 Days') {
      this.filter.date.endDate = this.dateService.subDaysInDatetime(datetime, 90, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter.date.startDate = null;
    }

    this.filter.date.filterTitle = this.filterTitle.aging;
    this.closeAfterAction = !this.closeAfterAction;
    this.filterApplied['aging'] = true;
    this.filterChange.emit(this.filter);
  }

  onSelectPaymentStatus(event) {
    if (event && event.id) {
      this.filter.paymentStatus = event;
      this.filterTitle.paymentStatus = event.name;
    } else {
      this.filter.paymentStatus = null;
      this.filterTitle.paymentStatus = 'Payment';
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectCreditStatus(event) {
    if (event && event.id) {
      this.filter.creditMemo = event;
      this.filterTitle.creditMemo = event.name;
    } else {
      this.filter.creditMemo = null;
      this.filterTitle.creditMemo = 'Credit Memo';
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectItemPaymentStatus(event) {
    if (event && event.id) {
      this.filter.itemPaymentStatus = event;
      this.filterTitle.itemPaymentStatus = event.name;
    } else {
      this.filter.itemPaymentStatus = null;
      this.filterTitle.itemPaymentStatus = 'Payment status';
    }
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectCompanyName(event) {
    this.filter.companyName.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectSupplierName(event) {
    // this.filter.supplier.selected = event;
    this.filter.supplier = { selected: event };
    this.closeAfterAction = false;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectItemTaxTypeName(event) {
    this.filter.taxItemType.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectItemCategory(event) {
    this.filter.itemCategory.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  onSelectGenericFilter(event) {
    this.filter.genericFilter.selected = event;
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.filterChange.emit(this.filter);
  }

  updateDateRangeTitle() {
    // chech which date filter applied to update date range title
    const startDateTime = this.dateService.formatDate(new Date(`${this.filter.date.startDate} 00:00`), datetimeFormat.mmmdyyyy);
    const endDateTime = this.dateService.formatDate(new Date(`${this.filter.date.endDate} 23:59`), datetimeFormat.mmmdyyyy);

    this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
  }

  updatePaidStatuFilter() {
    this.filterApplied.paidStatus = false;
  }

  onDateSelect(id: string) {
    let startDateTime: any,
      endDateTime: any,
      datetime: any = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    if (id === 'today') {
      datetime = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      this.filter.date.startDate = datetime;
      this.filter.date.endDate = datetime;
      startDateTime = this.dateService.formatDate(`${datetime}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = startDateTime;
      this.dateTitle = startDateTime;
      this.filter.date.filterTitle = 'Today';
      this.filterTitle.date = 'Today';
      this.filter.date.filterTitle = 'Today';
    } else if (id === 'yesterday') {
      datetime = this.dateService.subDaysInDatetime(datetime, 1, this.momentPeriod.day, datetimeFormat.yyymmdd);
      this.filter.date.startDate = datetime;
      this.filter.date.endDate = datetime;
      this.filterTitle.date = 'Yesterday';
      this.filter.date.filterTitle = 'Yesterday';
      this.filter.date.filterTitle = 'Yesterday';
      startDateTime = this.dateService.formatDate(`${datetime}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = startDateTime;
      this.dateTitle = startDateTime;
    } else if (id === 'this-week') {
      this.filter.date.startDate = this.dateService.getStartOfThisWeek(datetime, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.getEndOfThisWeek(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);

      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle.date = 'This week';
      this.filter.date.filterTitle = 'This week';
    } else if (id === 'last-week') {
      datetime = this.dateService.subDaysInDatetime(datetime, 1, 'isoWeek', datetimeFormat.yyymmdd);
      this.filter.date.startDate = this.dateService.getStartOfThisWeek(`${datetime}T00:00:00`, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.getEndOfThisWeek(`${datetime}T00:00:00`, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle.date = 'Last week';
      this.filter.date.filterTitle = 'Last week';
    } else if (id === 'this-month') {
      this.filter.date.startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.getEndOfThisMonth(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDate(startDateTime, datetimeFormat.mmmyyyy);
      this.filterTitle.date = 'This month';
      this.filter.date.filterTitle = 'This month';
    } else if (id === 'last-month') {
      datetime = this.dateService.subDaysInDatetime(datetime, 1, 'month', datetimeFormat.yyymmdd);
      this.filter.date.startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.getEndOfThisMonth(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDate(startDateTime, datetimeFormat.mmmyyyy);
      this.filterTitle.date = 'Last month';
      this.filter.date.filterTitle = 'Last month';
    } else if (id === 'year-to-date') {
      this.filter.date.startDate = this.dateService.getStartOfThisYear(datetime, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
      this.filterTitle.date = 'Year to date';
      this.filter.date.filterTitle = 'Year to date';
    } else if (id === 'all-time') {
      this.filter.date.startDate = '2000-01-01';
      this.filter.date.endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      this.dateTitle = 'All time';
      this.filterTitle.date = 'All time';
      this.filter.date.filterTitle = 'All time';
    } else if (id === 'custom') {
      /*
      Every time when we select custom date so it selected the current month date.
      */
      if (this.filterTitle.date !== 'Custom') {
        this.filter.date.startDate = this.dateService.getStartOfThisMonth(datetime, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      }
      if (this.id === 'technician-attendance-log') {
        this.hasAttendanceDate = true;
      }
      const ref = this.dialogService.open(GroupDatePickerDialogComponent, {
        styleClass: 'add-dialog group-date-picker-dialog',
        showHeader: false,
        data: {
          ...this.filter.date,
          currentDate: this.currentDateTime,
          id: this.id,
          hasAttendanceDate: this.hasAttendanceDate,
          path: this.path,
          filter: this.filter,
          type: this.data.type,
          selectedDateTitle: this.selectedDateTitle,
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, startDate, endDate }) => {
        if (isSuccess) {
          this.filter.date.startDate = this.dateService.formatDate(`${startDate}T00:00:00`, datetimeFormat.yyymmdd);
          this.filter.date.endDate = this.dateService.formatDate(`${endDate}T00:00:00`, datetimeFormat.yyymmdd);
          startDateTime = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
          endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy);
          this.dateTitle = this.dateService.formatDateRange(startDateTime, endDateTime);
          this.closeAfterAction = !this.closeAfterAction;
          localStorage.removeItem('retain-date');
          this.helperService.saveLocalStorage('retain-date', {
            ...this.filter.date,
            id: id,
            dateTitle: this.dateTitle,
          });
          this.filterChange.emit(this.filter);
        }
        onClose.unsubscribe();
      });

      this.filterTitle.date = 'Custom';
      this.filter.date.filterTitle = 'Custom';
    } else if (id === 'passed-day') {
      this.dateTitle = this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy);
      this.filterTitle.date = this.dateTitle;
      this.filter.date.filterTitle = this.dateTitle;
      return;
    }
    // Single Day
    else if (id === 'customEnd' || id === 'customMonthEnd') {
      /*
      Every time when we select custom date so it selected the current month date.
      */
      if (this.filterTitle.date !== 'Custom') {
        this.filter.date.endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
      }
      if (this.id === 'technician-attendance-log') {
        this.hasAttendanceDate = true;
      }
      const ref = this.dialogService.open(GroupDatePickerDialogComponent, {
        styleClass: 'add-dialog group-date-picker-dialog end-date-picker-dialog',
        showHeader: false,
        data: {
          ...this.filter.date,
          currentDate: this.currentDateTime,
          id: this.id,
          hasAttendanceDate: this.hasAttendanceDate,
          path: this.path,
          filter: this.filter,
          type: this.data.type,
          selectedDateTitle: this.selectedDateTitle,
          isEndDatePickerOnly: true,
          isCustomMonth: id === 'customMonthEnd' ? true : false,
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, startDate, endDate }) => {
        if (isSuccess) {
          this.filter.date.startDate = this.dateService.formatDate(`${startDate}T00:00:00`, datetimeFormat.yyymmdd);
          this.filter.date.endDate = this.dateService.formatDate(`${endDate}T00:00:00`, datetimeFormat.yyymmdd);
          endDateTime = this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, this.options.singleMonth ? datetimeFormat.mmmyyyy : datetimeFormat.mmmdyyyy);

          this.dateTitle = this.dateService.formatEndDateRange(endDateTime);
          this.closeAfterAction = !this.closeAfterAction;
          localStorage.removeItem('retain-date');
          this.helperService.saveLocalStorage('retain-date', {
            ...this.filter.date,
            id: id,
            dateTitle: this.dateTitle,
          });
          this.filterChange.emit(this.filter);
        }
        onClose.unsubscribe();
      });

      this.filterTitle.date = 'Custom';
      this.filter.date.filterTitle = 'Custom';
    }

    if (!['/reports/google-review', '/reports/acc-payable-supplier', '/reports/orderarbycustomer', '/reports/technician-attendance-log-details'].includes(this.path)) {
      if (!['/reports/acc-payable-supplier', '/reports/inventory-level-reports', '/reports/orderarbycustomer'].includes(this.path) && id !== 'custom') {
        localStorage.removeItem('retain-date');
        this.helperService.saveLocalStorage('retain-date', {
          ...this.filter.date,
          id: id,
          dateTitle: this.dateTitle,
        });
      }
    }

    if (this.updateUrl) {
      if (this.path === '/reports/canned-service-detail' && this.filter.title) {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
      } else if (this.path === '/reports/fee-drill-down-report') {
        this.location.replaceState(`${this.path}/${this.data.type}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
        this.filterChange.emit(this.filter);
      } else if (this.path === '/reports/discount-drill-down-report') {
        this.location.replaceState(`${this.path}/${this.data.type}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
      } else if (this.path === '/reports/labor-reporting-drill-down') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.filter.title}`);
      } else if (this.path === '/reports/supplier-detail') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
      } else if (this.path === '/reports/technician-summary-all-service-details') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
      } else if (this.path === '/reports/technician-detail') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
      } else if (this.path === '/reports/drill-down-report') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}/${this.serviceWriterId}`);
      } else if (this.path === '/reports/tax-detail') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.selectedDateTitle}/${this.filter.title}`);
      } else if (this.path === '/reports/royalty') {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}`);
      } else {
        this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.filter.title}`);
      }
    }

    this.filterApplied.date = id;

    if (this.filterApplied.date !== 'custom') {
      this.closeAfterAction = !this.closeAfterAction;
      this.filterChange.emit(this.filter);
    }
  }

  clearFilter(type: string = '', triggerFilterChange: boolean = true) {
    switch (type) {
      case 'qboStatus':
        this.filter.qboStatus = {};
        this.filter.qboStatus.synced = false;
        this.filter.qboStatus.notSynced = false;
        this.filter.qboStatus.notPosted = false;
        this.filterApplied.qboStatus = false;
        break;

      case 'paymentSubType':
        this.filter.paymentSubTypeFilterOption.map((rec) => {
          rec.selected = false;
        });
        this.filterApplied.paymentSubType = false;
        break;

      case 'paymentType':
        this.filter.paymentType = {
          cash: false,
          card: false,
          cheque: false,
          creditPayment: false,
        };
        this.filter.paymentSubTypeFilterOption = [];
        this.filterApplied.paymentSubType = false;
        this.filterApplied.paymentType = false;
        break;

      case 'archives':
        this.filter.archives = {
          archived: false,
          unArchived: false,
        };
        break;

      case 'paymentGroup':
        this.filter.paymentGroup = {
          payment: false,
          refund: false,
          void: false,
        };
        break;

      case 'payment':
        this.filter.payment = {
          unpaid: false,
          partiallyPaid: false,
        };
        this.filterApplied.payment = false;
        break;

      case 'activity':
        this.filter.activity = {
          inspections: false,
          services: false,
        };
        break;

      case 'tech':
        this.technicians = this.helperService.deepCopy(this.defalutTechnicians);
        this.technicians = this.sortActiveFirst(this.technicians);
        this.filter.tech = null;
        break;

      case 'salesGroup':
        this.salesGroupsResults = this.helperService.deepCopy(this.defalutSalesGroup);
        this.filter.salesGroup = null;
        break;

      case 'salesCode':
        this.salesCodeResults = this.helperService.deepCopy(this.defalutSalesCode);
        this.filter.salesCode = null;
        break;

      case 'serviceWriter':
        this.serviceWriters = this.helperService.deepCopy(this.defalutServiceWriters);
        this.serviceWriterUsers = this.sortActiveFirst(this.serviceWriterUsers);
        this.filter.serviceWriter = null;
        break;

      case 'tags':
        this.tags = this.helperService.deepCopy(this.defalutTags);
        if (this.filter?.tags?.selected) {
          this.filter.tags.selected = [];
        }
        break;

      case 'itemTypeInventoryNonInventory':
        this.itemTypeInventoryNonInventory = this.helperService.deepCopy(this.defaultItemTypeInventoryNonInventory);
        if (this.filter?.itemTypeInventoryNonInventory?.selected) {
          this.filter.itemTypeInventoryNonInventory.selected = [];
        }
        break;

      case 'payableStatus':
        this.payableStatusList = this.helperService.deepCopy(this.defaultPayableStatus);
        if (this.filter?.payableStatus?.selected) {
          this.filter.payableStatus.selected = [];
        }
        break;

      case 'orderType':
        this.orderTypeList = this.helperService.deepCopy(this.defaultOrderTypeList);
        if (this.filter?.orderType?.selected) {
          this.filter.orderType.selected = [];
        }
        break;

      case 'activityType':
        this.activityTypeList = this.helperService.deepCopy(this.defaultActivityTypeList);
        if (this.filter?.activityType?.selected) {
          this.filter.activityType.selected = [];
        }
        break;

      case 'items':
        this.items = this.helperService.deepCopy(this.defalutItems);
        if (this.filter?.items?.selected) {
          this.filter.items.selected = [];
        }
        break;

      case 'location':
        this.locations = this.helperService.deepCopy(this.defalutLocations);
        if (this.filter?.location?.selected) {
          this.filter.location.selected = [];
        }
        break;

      case 'multiTaxCode':
        if (this.filter?.multiTaxCode?.selected) {
          this.filter.multiTaxCode.selected = [];
          this.taxCodeList = this.taxCodeList.map((item) => ({
            ...item,
            isChecked: false,
          }));
        }
        break;

      case 'category':
        this.categories = this.helperService.deepCopy(this.defalutCategories);
        this.filterTitle.category = 'Category';
        this.filter.category = null;
        break;

      case 'workflow':
        this.workFlowStatuses = this.helperService.deepCopy(this.defaultWorkFlowStatuses);
        this.filter.workflow = null;
        this.filterTitle.workflow = 'Workflow';
        break;

      case 'taxCode':
        this.taxCodes = this.helperService.deepCopy(this.taxCodes);
        this.filter.taxCode = null;
        this.filterTitle.taxCode = 'taxCode';
        this.dataService.taxCode = '';
        break;

      case 'aging':
        this.agingOptions = this.helperService.deepCopy(this.defaultAgingOptions);
        this.filterTitle.aging = 'Aging';
        this.filter.aging = null;
        this.filter.date = this.filter.date || {};
        this.filter.date.startDate = this.tempRestAgingDate.startDate;
        this.filter.date.endDate = this.tempRestAgingDate.endDate;
        break;

      case 'paymentStatus':
        this.paymentStatusOptions = this.helperService.deepCopy(this.defaultPaymentStatusOptions);
        this.filter.paymentStatus = null;
        this.filterTitle.paymentStatus = 'Payment';
        break;

      case 'creditMemo':
        this.creditMemoOptions = this.helperService.deepCopy(this.defaultCreditMemoOptions);
        this.filter.creditMemo = null;
        this.filterTitle.creditMemo = 'Credit Memo';
        break;

      case 'itemPaymentStatus':
        this.itemPaymentStatusOptions = this.helperService.deepCopy(this.defaultItemPaymentStatusOptions);
        this.filter.itemPaymentStatus = null;
        this.filterTitle.itemPaymentStatus = 'Payment status';
        break;

      case 'companyName':
        this.companyNames = this.helperService.deepCopy(this.defaultCompanyNames);
        if (this.filter?.companyName?.selected) this.filter.companyName.selected = [];
        break;

      case 'supplier':
        if (this.filter?.supplier?.selected) this.filter.supplier.selected = [];
        this.suppliers = this.suppliers.map((supplier) => ({
          ...supplier,
          isChecked: false,
        }));
        break;

      case 'taxItemType':
        if (this.filter?.taxItemType?.selected) this.filter.taxItemType.selected = [];
        this.dataService.taxType = '';
        this.taxItemTypes = this.taxItemTypes.map((item) => ({
          ...item,
          isChecked: false,
        }));
        break;

      case 'itemCategory':
        if (this.filter?.itemCategory?.selected) this.filter.itemCategory.selected = [];
        this.itemCategorys = this.itemCategorys.map((itemCategory) => ({
          ...itemCategory,
          isChecked: false,
        }));
        break;

      case 'lastSold':
        this.lastSoldOptions = this.helperService.deepCopy(this.defalutLastSoldOptions);
        this.filter.lastSold = null;
        this.filterTitle.lastSold = 'Last sold';
        break;

      case 'rating':
        this.ratingOptions = this.helperService.deepCopy(this.defalutRatingOptions);
        this.filter.rating = null;
        this.filterTitle.rating = 'Ratings';
        break;

      case 'statementStatus':
        this.statmentOptions = this.helperService.deepCopy(this.defalutStatementOptions);
        this.ratingOptions[0].isChecked = false;
        this.ratingOptions[1].isChecked = true;
        this.filter.statementStatus = null;
        this.filterTitle.statementTitle = 'Statement';
        break;

      case 'customerType':
        this.filter.customerType = {
          newCustomers: false,
          repeatCustomers: false,
        };
        this.filterTitle.rating = 'Customer Type';
        break;

      case 'supplierType':
        this.filter.supplierType = {
          internal: false,
          online: false,
        };
        break;

      case 'feeType':
        this.filter.feeType = {
          serviceLevel: false,
          roLevel: false,
        };
        break;

      case 'itemType':
        this.filter.itemType = {
          tire: false,
          part: false,
          labor: false,
          sublet: false,
          tireStorage: false,
          other: false,
        };
        break;

      case 'warrantyType':
        this.filter.warrantyType = {
          first: false,
          replacement: false,
        };
        break;

      case 'orderOn':
        this.filter.orderOn = {
          orderLevel: false,
          serviceLevel: false,
        };
        break;

      case 'orderDiscountType':
        this.filter.orderDiscountType = {
          percentage: false,
          dollarValue: false,
        };
        break;

      case 'customerFleet':
        this.filter.customerFleet = {
          regular: false,
          fleet: false,
        };
        this.getDateFilterDisableForAR();
        break;

      case 'orderStatus':
        this.filter.orderStatus = {
          estimate: false,
          invoice: false,
          finalized: false,
        };
        this.filterTitle.rating = 'Customer Type';
        break;

      case 'roStatus':
        // this.filter.roStatus = { ...this.defaultRoStatus }; // ✅ Reset based on `@Input()`
        this.filter.roStatus = {
          estimate: false,
          invoice: false,
          finalized: false,
        }
        this.filterTitle.roStatus.all = 'RO Status';
        break;

      case 'qtyType':
        this.resetQtyTypeFilters();
        break;

      case 'sendStatus':
        this.resetSentStatusFilters();
        break;

      case 'paidStatus':
        this.resetPaidStatusFilters();
        break;
      case 'orderingMethods':
        this.filter.orderingMethods = {
          online: false,
          offline: false,
          provisional: false,
          inventory: false,
        };
        break;
      case 'orderingStatus':
        this.filter.orderingStatus = {
          unordered: false,
          ordered: false,
          delivered: false,
          cancelled: false,
        };
        break;
      case 'paymentTerms':
        this.filter.paymentTerms = {
          payable: false,
          cod: false,
        };
        break;
      case 'genericFilter':
        this.filter.genericFilter = {
          selected: [],
        };
        this.genericFilterData = this.genericFilterData.map((data) => ({
          ...data,
          isChecked: false,
        }));
        break;
      case 'orderStatusTechSummary':
        this.orderStatusForAllServices = this.helperService.deepCopy(this.defaultOrderStatusForAllServices);
        this.filter.orderStatusTechSummary = null;
        break;
    }

    Object.keys(this.filterApplied).forEach((item) => {
      if (item === type) {
        this.filterApplied[item] = false;
      }
    });
    this.closeAfterAction = !this.closeAfterAction;
    this.whichFilterApplied();
    this.closeAfterAction = !this.closeAfterAction;
    if (triggerFilterChange) {
      this.filterChange.emit(this.filter);
    }

    this.onClearFilter.emit();
  }

  techNameDisplay() {
    if (!this.filter.tech) {
      return this.filterTitle.tech.all;
    } else if (this.filter.tech) {
      return this.techNames([this.filter.tech]);
    }
  }


  salesGroupDisplay() {
    if (!this.filter.salesGroup) {
      return this.filterTitle.salesGroup.all;
    } else if (this.filter.salesGroup) {
      return this.filter.salesGroup.name;
    }
  }

  salesCodeDisplay() {
    if (!this.filter.salesCode) {
      return this.filterTitle.salesCode.all;
    } else if (this.filter.salesCode) {
      return this.filter.salesCode.title;
    }
  }

  orderStatusAllServiceNameDisplay() {
    if (!this.filter.orderStatusTechSummary) {
      return this.filterTitle.orderStatusTechSummary.all;
    } else if (this.filter.orderStatusTechSummary) {
      return this.orderStatusAllServiceName([this.filter.orderStatusTechSummary]);
    }
  }

  serviceWriterDisplay() {
    if (!this.filter.serviceWriter) {
      return this.filterTitle.serviceWriter.all;
    } else if (this.filter.serviceWriter) {
      return this.serviceWriterNames([this.filter.serviceWriter]);
    }
  }

  serviceWriterNames(names) {
    let name = '';
    const l = names.length - 1;
    names.forEach((n, i) => {
      name += this.helperService.firstNameAndLastInitial(n.name);
      if (i !== l) {
        name += ', ';
      }
    });

    return name;
  }

  techNames(names) {
    let name = '';
    const l = names.length - 1;
    names.forEach((n, i) => {
      name += this.helperService.firstNameAndLastInitial(n.name);
      if (i !== l) {
        name += ', ';
      }
    });

    return name;
  }

  orderStatusAllServiceName(names) {
    let name = '';
    const l = names.length - 1;
    names.forEach((n, i) => {
      name += n.name;
      // if (i !== l) {
      //   name += ', ';
      // }
    });

    return name;
  }

  whichFilterApplied(type: string = '') {
    const {
      customerType = {},
      supplierType = {},
      feeType = {},
      orderOn = {},
      orderDiscountType = {},
      itemType = {},
      warrantyType = {},
      customerFleet = {},
      activity = {},
      archives = {},
      paymentGroup = {},
      orderStatus = {},
      roStatus = {},
      tech,
      salesGroup,
      salesCode,
      serviceWriter,
      lastSold,
      rating,
      statementStatus,
      workflow,
      taxCode,
      category,
      aging,
      paymentStatus,
      creditMemo,
      itemPaymentStatus,
      orderStatusTechSummary,
      companyName = { selected: [] },
      supplier = !!(this.filter.supplier && this.filter.supplier.selected && this.filter.supplier.selected.length),
      taxItemType = !!(this.filter.taxItemType && this.filter.taxItemType.selected && this.filter.taxItemType.selected.length),
      itemCategory = !!(this.filter.itemCategory && this.filter.itemCategory.selected && this.filter.itemCategory.selected.length),
      tags = { selected: [] },
      payableStatus = { selected: [] },
      itemTypeInventoryNonInventory = { selected: [] },
      orderType = { selected: [] },
      items = { selected: [] },
      location = { selected: [] },
      multiTaxCode = !!(this.filter.multiTaxCode && this.filter.multiTaxCode.selected && this.filter.multiTaxCode.selected.length),
      genericFilter,
      activityType = { selected: [] },
      isFilterByFinalizeDate = false,
    } = this.filter;

    // ✅ Check if `defaultRoStatus` should be considered active
    const isDefaultRoStatus = JSON.stringify(roStatus) === JSON.stringify(this.defaultRoStatus);

    if (type === 'qtyType') {
      this.filterApplied.qtyType = this.isQuantityFilterApplied();
    }

    if (type === 'sendStatus') {
      this.filterApplied.sendStatus = this.isSendStatusFilterApplied();
    }

    this.filterApplied.paidStatus = this.isPaidStatusFilterApplied();
    this.filterApplied.customerType = customerType.newCustomers || customerType.repeatCustomers;
    this.filterApplied.supplierType = supplierType.internal || supplierType.online;
    this.filterApplied.feeType = feeType.serviceLevel || feeType.roLevel || feeType.passThroughTax;
    this.filterApplied.orderOn = orderOn.orderLevel || orderOn.serviceLevel;
    this.filterApplied.orderDiscountType = orderDiscountType.percentage || orderDiscountType.dollarValue;
    this.filterApplied.itemType = itemType.tire || itemType.part || itemType.sublet || itemType.tireStorage || itemType.other || itemType.labor;
    this.filterApplied.warrantyType = warrantyType.replacement || warrantyType.first;
    this.filterApplied.customerFleet = customerFleet.regular || customerFleet.fleet;
    this.filterApplied.activity = activity.inspections || activity.services;
    this.filterApplied.archives = archives.archived || archives.unArchived;
    this.filterApplied.paymentGroup = paymentGroup.refund || paymentGroup.payment || paymentGroup.void;
    this.filterApplied.orderStatus = orderStatus.estimate || orderStatus.invoice || orderStatus.finalized;
    this.filterApplied.roStatus = isDefaultRoStatus;  // ✅ Depend on `@Input()`
    this.filterApplied.tech = !!tech;
    this.filterApplied.salesGroup = !!salesGroup;
    this.filterApplied.salesCode = !!salesCode;
    this.filterApplied.serviceWriter = !!serviceWriter;
    this.filterApplied.lastSold = !!lastSold;
    this.filterApplied.rating = !!rating;
    this.filterApplied.statementStatus = !!statementStatus;
    this.filterApplied.workflow = !!workflow;
    this.filterApplied.taxCode = !!taxCode;
    this.filterApplied.category = !!category;
    this.filterApplied.aging = !!aging;
    this.filterApplied.paymentStatus = !!paymentStatus;
    (this.filterApplied.creditMemo = !!creditMemo), (this.filterApplied.itemPaymentStatus = !!itemPaymentStatus);
    this.filterApplied.companyName = companyName.selected && companyName.selected.length ? true : false;
    this.filterApplied.supplier = supplier.selected && supplier.selected.length;
    this.filterApplied.taxItemType = (taxItemType?.selected && taxItemType.selected?.length);
    this.filterApplied.itemCategory = itemCategory.selected && itemCategory.selected.length;
    this.filterApplied.tags = tags.selected && tags.selected.length;
    this.filterApplied.payableStatus = payableStatus.selected && payableStatus.selected.length;
    this.filterApplied.itemTypeInventoryNonInventory = itemTypeInventoryNonInventory.selected && itemTypeInventoryNonInventory.selected.length && true;
    this.filterApplied.orderType = orderType.selected && orderType.selected.length;
    this.filterApplied.items = items.selected && items.selected.length;
    this.filterApplied.location = location.selected && location.selected.length;
    this.filterApplied.multiTaxCode = multiTaxCode.selected && multiTaxCode.selected.length;
    this.filterApplied.genericFilter = !!(genericFilter && genericFilter.selected && genericFilter.selected.length);
    this.filterApplied.orderStatusTechSummary = !!orderStatusTechSummary;
    this.filterApplied.activityType = activityType.selected && activityType.selected.length;

    if (type === 'paymentType') {
      this.filter.paymentSubTypeFilterOption = [];
      const { cash, card, cheque, thirdParty, writeOff, cardManual, cardOnline, cardSwipe, creditPayment } = this.filter.paymentType;




      this.filterApplied.paymentType = (!cash || !card || !cheque || !thirdParty || !writeOff) && (cash || card || cheque || thirdParty || writeOff);

      if (cash) {
        this.filter.paymentSubTypeFilterOption = [...this.filter.paymentSubTypeFilterOption, ...this.cashPaymentMethods];
      }

      if (creditPayment) {
        this.filter.paymentSubTypeFilterOption = [...this.filter.paymentSubTypeFilterOption, ...[{ name: "Credit Memo" }]];
      }

      if (cardOnline || cardManual || cardSwipe || card) {
        this.filter.paymentSubTypeFilterOption = [...this.filter.paymentSubTypeFilterOption, ...this.cardPaymentMethods];
      }

      if (cheque) {
        this.filter.paymentSubTypeFilterOption = [...this.filter.paymentSubTypeFilterOption, ...this.otherPaymentMethods];
      }

      if (thirdParty) {
        this.filter.paymentSubTypeFilterOption = [...this.filter.paymentSubTypeFilterOption, ...this.thirdPartyPaymentMethods];
      }

      if (writeOff) {
        this.filter.paymentSubTypeFilterOption = [...this.filter.paymentSubTypeFilterOption, ...this.writeOffPaymentMethods];
      }
    }

    if (type === 'qboStatus') {
      const { synced, notSynced, notPosted } = this.filter.qboStatus;

      this.filterApplied.qboStatus = (!synced || !notSynced || !notPosted) && (synced || notSynced || notPosted);
    }

    if (type === 'orderingStatus') {
      const { unordered, ordered, delivered, cancelled } = this.filter.orderingStatus;

      this.filterApplied.orderingStatus = unordered || ordered || delivered || cancelled;
    }

    if (type === 'paymentTerms') {
      const { payable, cod } = this.filter.paymentTerms;

      this.filterApplied.paymentTerms = payable || cod;
    }

    if (type === 'orderingMethods') {
      const { online, offline, provisional, inventory } = this.filter.orderingMethods;

      this.filterApplied.orderingMethods = online || offline || provisional || inventory;
    }

    // reset on RO filter
    this.options && this.options.feeType ? this.filterApplied.feeType : (this.filterApplied.feeType = false);
    this.options && this.options.creditMemo ? this.filterApplied.creditMemo : (this.filterApplied.creditMemo = false);
    this.filterArrayCount = Object.values(this.filterApplied).filter((item) => (item === true)).length;

    if (this.filterArrayCount === 0 && isDefaultRoStatus) {
      this.filterArrayCount = 1; // ✅ Ensures `roStatus` is counted on default
    }
  }

  resetFilters(forcedReset?: boolean): void {
    this.filterDrawer = false;
    // this.isLoading = true; // Start loading indicator

    setTimeout(() => {
      const startDate = this.filter.date?.startDate;
      const endDate = this.filter.date?.endDate;

      if (!this.filterApplied) {
        console.warn('Warning: filterApplied is undefined');
        // this.isLoading = false;
        return;
      }

      Object.keys(this.filterApplied).forEach((item: any) => {
        // Fee type is by default selected
        if (item === 'feeType' || item === 'roStatus') return;
        if (item !== 'date' || item !== 'singleDay') {
          if (!['items-enhance-item-sold-detail', 'items-enhance-item-sold'].includes(this.id) || forcedReset) {
            this.clearFilter(this.filterConst[item], false);
          }
        }
      });

      this.clearFilter('genericFilter');

      // Reset start and end date
      if (this.filter?.date) {
        this.filter.date.startDate = startDate;
        this.filter.date.endDate = endDate;
      }

      // this.isLoading = false; // Stop loader after operations are done
      this.filterChange.emit(this.filter);

    }, 300); // Adding a short delay to improve UX
  }


  getCompanyLocation() {
    const { employeeId } = this.helperService.getCompany();

    this.httpService.getShopLists({ employeeId }).then(
      (data) => {
        this.companyLocations = data.records || [];
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Fetch payments and set the qboId for the non credit card payment */
  fetchPaymentMethods() {
    this.httpService.getActivePaymentMethods().then(
      (paymentMethods: any[]) => {
        console.log(paymentMethods, 'methodssssssssssssssssssssssss');
        this.paymentMethods = this.helperService.deepCopy(paymentMethods);
        paymentMethods.forEach((method) => {

          if (method.type === 'CREDIT_CARD') {
            this.cardPaymentMethods.push({ ...method, selected: false });
          } else if (method.name.toLowerCase().includes('cash')) {
            this.cashPaymentMethods.push({ ...method, selected: false });
          } else if (method.type === 'THIRD_PARTY') {
            this.thirdPartyPaymentMethods.push({ ...method, selected: false });
          } else if (method.type === 'WRITE_OFF') {
            this.writeOffPaymentMethods.push({ ...method, selected: false });
          } else {
            this.otherPaymentMethods.push({ ...method, selected: false });
          }
        });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  showPaymentPill() {
    if (this.filter.payment.unpaid === false && this.filter.payment.partiallyPaid === false) {
      return 'Payment';
    } else if (this.filter.payment.unpaid && this.filter.payment.partiallyPaid) {
      return 'Payment';
    } else if (this.filter.payment.unpaid && !this.filter.payment.partiallyPaid) {
      return this.filterTitle.payment.unpaid;
    } else if (!this.filter.payment.unpaid && this.filter.payment.partiallyPaid) {
      return this.filterTitle.payment.partiallyPaid;
    } else if (!this.filter.payment.unpaid && !this.filter.payment.partiallyPaid) {
      return this.filterTitle.payment.paid;
    } else if (this.filter.payment.unpaid && !this.filter.payment.partiallyPaid) {
      return 'Paid & unpaid Orders';
    } else if (this.filter.payment.unpaid && this.filter.payment.partiallyPaid) {
      return 'Partially paid & unpaid Orders';
    }
  }

  showCerditMemoPill() {
    if (this.filter.creditMemo.issuancesOnly === false && this.filter.creditMemo.applicationOnly === false) {
      return 'Credit Memo';
    } else if (this.filter.creditMemo.issuancesOnly) {
      return 'Issuances Only';
    } else if (this.filter.creditMemo.applicationOnly) {
      return 'Application Only';
    }
  }

  showPaymentTypeTitle() {
    const { cash, card, cheque, creditPayment, cardManual, cardOnline, cardSwipe } = this.filter.paymentType;

    if ((cash && card && cheque && cardManual && cardOnline && cardSwipe && creditPayment) || (!cash && !card && !cheque && !cardManual && !cardOnline && !cardSwipe && !creditPayment)) {
      return 'Payment type';
    } else {
      let title: any = `${cash ? 'Cash, ' : ''}${card ? 'Card, ' : ''}${cheque ? 'Check, ' : ''}${creditPayment ? 'Credit, ' : ''}${cardManual ? 'Card Manual, ' : ''}${cardOnline ? 'Card Online, ' : ''
        }${cardSwipe ? 'Card Swipe, ' : ''}`;
      title = title.trim().split(',');
      this.filterApplied.paymentType =
        (!cash || !card || !cheque || !cardManual || !cardOnline || !cardSwipe || !creditPayment) && (cash || card || cheque || cardManual || cardOnline || cardSwipe || creditPayment);
      title.pop();
      return title.join(', ');
    }
  }

  showOrderingMethodsTitle() {
    const { online, offline, provisional, inventory } = this.filter.orderingMethods;
    if ((online && offline && provisional && inventory) || (!online && !offline && !provisional && !inventory)) {
      return 'Ordering method';
    } else {
      const selection = [online, offline, provisional, inventory];
      if (selection.filter((value) => value).length === 1) {
        let title: any = `${online ? 'Online, ' : ''}${offline ? 'Offline, ' : ''}${provisional ? 'Provisional, ' : ''}${inventory ? 'Inventory, ' : ''}`;
        title = title.trim().split(',');
        title.pop();
        return title.join(', ');
      } else {
        return 'Ordering method';
      }
    }
  }

  showOrderingStatusTitle() {
    const { unordered, ordered, delivered, cancelled } = this.filter.orderingMethods;

    if ((unordered && ordered && delivered && cancelled) || (!unordered && !ordered && !delivered && !cancelled)) {
      return 'Ordering status';
    } else {
      let title: any = `${unordered ? 'Unordered, ' : ''}${ordered ? 'Ordered, ' : ''}${delivered ? 'Delivered, ' : ''}${cancelled ? 'cancelled, ' : ''}`;
      title = title.trim().split(',');
      title.pop();
      return title.join(', ');
    }
  }

  showPaymenTermsTitle() {
    const { payable, cod } = this.filter.paymentTerms;

    if ((payable && cod) || (!payable && !cod)) {
      return 'Payment terms';
    } else {
      let title: any = `${payable ? 'Payable, ' : ''}${cod ? 'COD, ' : ''}`;
      title = title.trim().split(',');
      title.pop();
      return title.join(', ');
    }
  }

  showqboStatusTitle() {
    const { synced, notSynced, notPosted } = this.filter.qboStatus;

    if ((synced && notSynced && notPosted) || (!synced && !notSynced && !notPosted)) {
      return 'QuickBooks';
    } else {
      let title: any = `${synced ? 'Synced, ' : ''}${notSynced ? 'Out of Synced, ' : ''}${notPosted ? 'Not posted, ' : ''}`;
      title = title.trim().split(',');
      title.pop();
      return title.join(', ');
    }
  }

  back() {
    this.location.back();
  }

  dateBack() {
    if (this.id === 'technician-attendance-log') {
      const datetime: Date = this.filter.date.startDate ? new Date(`${this.filter.date.startDate}T00:00:00`) : this.dateService.getCurrentDateTimeTz(this.currentDateTime);

      const firstDay: Date = new Date(datetime.getFullYear(), datetime.getMonth() - 1, 1);
      const lastDay: Date = new Date(datetime.getFullYear(), datetime.getMonth(), 0);

      this.filter.date.startDate = this.dateService.formatDate(firstDay, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(lastDay, datetimeFormat.yyymmdd);

      this.dateTitle = this.dateService.formatDate(firstDay, datetimeFormat.mmmyyyy);
      this.filterApplied.date = 'custom';
      this.filterTitle.date = 'custom';
      this.filter.date.filterTitle = 'custom';
      this.filterChange.emit(this.filter);
      return;
    } else if (this.id === 'technician-attendance-log-details') {
      let startDate: Date;
      let endDate: Date;
      // first check if day, week or month filter selected
      if (this.filterTitle.date === 'Yesterday' || this.filterTitle.date === 'Today') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        startDate.setDate(startDate.getDate() - 1);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        endDate.setDate(endDate.getDate() - 1);

        this.dateTitle = this.dateService.formatDate(startDate, datetimeFormat.mmmdyyyy);
      } else if (this.filterTitle.date === 'This week' || this.filterTitle.date === 'Last week') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setDate(startDate.getDate() - 7);
        endDate.setDate(endDate.getDate() - 7);
        this.filter.date.startDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(endDate, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDateRange(
          this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy),
          this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy),
        );
      } else if (this.filterTitle.date === 'This month' || this.filterTitle.date === 'Last month') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setMonth(startDate.getMonth() - 1);
        endDate.setMonth(endDate.getMonth() - 1);

        this.dateTitle = this.dateService.formatDate(startDate, datetimeFormat.mmmyyyy);
      } else if (this.filterTitle.date === 'Year to date') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setFullYear(startDate.getFullYear() - 1);
        endDate.setFullYear(endDate.getFullYear() - 1);
        this.filter.date.startDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(endDate, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDateRange(
          this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy),
          this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy),
        );
      } else {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setDate(startDate.getDate() - 1);
        endDate.setDate(endDate.getDate() - 1);

        const startDateFormatted = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
        const todayDate = this.dateService.formatDate(this.currentDateTime, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDate(startDate, datetimeFormat.mmmdyyyy);

        if (startDateFormatted == todayDate) {
          this.filterTitle.date = 'Today';
        } else {
          this.filterTitle.date = this.dateTitle;
          this.filter.date.filterTitle = this.dateTitle;
        }
      }

      this.filter.date.startDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(endDate, datetimeFormat.yyymmdd);

      this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.filter.title}`);

      this.filterChange.emit(this.filter);
      return;
    }

    const data = window.location.href.split('/');
    data.pop();
    const end = this.dateService.convertDate(data.pop());
    const start = this.dateService.convertDate(data.pop());

    if (start.isValid() && end.isValid()) {
      const s = start.clone();
      const e = end.clone();
      const endDate = start.subtract(1, 'day');
      const startDate = endDate.clone().subtract(e.diff(s, 'days'), 'days');

      this.filter.date.startDate = startDate;
      this.filter.date.endDate = endDate;
      this.filterChange.emit(this.filter);
    }
  }

  dateNext() {
    // if report is technician attendance log
    if (this.id === 'technician-attendance-log') {
      const datetime: Date = this.filter.date.startDate ? new Date(`${this.filter.date.startDate}T00:00:00`) : this.dateService.getCurrentDateTimeTz(this.currentDateTime);

      const firstDay: Date = new Date(datetime.getFullYear(), datetime.getMonth() + 1, 1);
      const lastDay: Date = new Date(datetime.getFullYear(), datetime.getMonth() + 2, 0);

      this.filter.date.startDate = this.dateService.formatDate(firstDay, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(lastDay, datetimeFormat.yyymmdd);

      this.dateTitle = this.dateService.formatDate(firstDay, datetimeFormat.mmmyyyy);
      this.filterApplied.date = 'custom';
      this.filterTitle.date = 'custom';
      this.filter.date.filterTitle = 'custom';
      this.filterChange.emit(this.filter);
      return;
    } else if (this.id === 'technician-attendance-log-details') {
      let startDate: Date;
      let endDate: Date;
      // first check if day, week or month filter selected
      if (this.filterTitle.date === 'Yesterday' || this.filterTitle.date === 'Today') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setDate(startDate.getDate() + 1);
        endDate.setDate(endDate.getDate() + 1);

        this.dateTitle = this.dateService.formatDate(startDate, datetimeFormat.mmmdyyyy);
      } else if (this.filterTitle.date === 'This week' || this.filterTitle.date === 'Last week') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setDate(startDate.getDate() + 7);
        endDate.setDate(endDate.getDate() + 7);
        this.filter.date.startDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(endDate, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDateRange(
          this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy),
          this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy),
        );
      } else if (this.filterTitle.date === 'This month' || this.filterTitle.date === 'Last month') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setMonth(startDate.getMonth() + 1);
        endDate.setMonth(endDate.getMonth() + 1);

        this.dateTitle = this.dateService.formatDate(startDate, datetimeFormat.mmmyyyy);
      } else if (this.filterTitle.date === 'Year to date') {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setFullYear(startDate.getFullYear() + 1);
        endDate.setFullYear(endDate.getFullYear() + 1);
        this.filter.date.startDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
        this.filter.date.endDate = this.dateService.formatDate(endDate, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDateRange(
          this.dateService.formatDate(`${this.filter.date.startDate}T00:00:00`, datetimeFormat.mmmdyyyy),
          this.dateService.formatDate(`${this.filter.date.endDate}T00:00:00`, datetimeFormat.mmmdyyyy),
        );
      } else {
        startDate = new Date(`${this.filter.date.startDate}T00:00:00`);
        endDate = new Date(`${this.filter.date.endDate}T00:00:00`);
        startDate.setDate(startDate.getDate() + 1);
        endDate.setDate(endDate.getDate() + 1);

        const startDateFormatted = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
        const todayDate = this.dateService.formatDate(this.currentDateTime, datetimeFormat.yyymmdd);

        this.dateTitle = this.dateService.formatDate(startDate, datetimeFormat.mmmdyyyy);

        if (startDateFormatted == todayDate) {
          this.filterTitle.date = 'Today';
          this.filter.date.filterTitle = 'Today';
        } else {
          this.filterTitle.date = this.dateTitle;
          this.filter.date.filterTitle = this.dateTitle;
        }
      }

      this.filter.date.startDate = this.dateService.formatDate(startDate, datetimeFormat.yyymmdd);
      this.filter.date.endDate = this.dateService.formatDate(endDate, datetimeFormat.yyymmdd);

      this.location.replaceState(`${this.path}/${this.filter.date.startDate}/${this.filter.date.endDate}/${this.filter.title}`);
      this.filterChange.emit(this.filter);
      return;
    }

    const data = window.location.href.split('/');
    data.pop();
    const end = this.dateService.convertDate(data.pop());
    const start = this.dateService.convertDate(data.pop());

    if (start.isValid() && end.isValid()) {
      const s = start.clone();
      const e = end.clone();
      const startDate = end.add(1, 'day');
      const endDate = startDate.clone().add(e.diff(s, 'days'), 'days');

      this.filter.date.startDate = startDate;
      this.filter.date.endDate = endDate;
      this.filterChange.emit(this.filter);
    }
  }

  getDaysInMonth(startDate: Date, endDate: Date) {
    let currentDate = new Date(startDate);
    this.attendanceCols = [
      { name: 'Technician', value: 'Technician' },
      {
        name: this.dateService.formatDate(currentDate, datetimeFormat.mmmyyyy),
        value: this.dateService.formatDate(currentDate, datetimeFormat.mmmyyyy),
      },
      { name: 'totalHours', value: 'Total Hours' },
    ];
    while (currentDate.getTime() <= endDate.getTime()) {
      const day = `${currentDate.getDate()}`;
      this.daysOfMonthMap[day] = 0;
      this.daysNameMap[`${this.dateService.get('D', currentDate)}`] = this.dateService.formatDate(currentDate, 'ddd');
      this.attendanceCols.push({
        name: day,
        value: `${day} ${this.daysNameMap[day]}`,
        date: new Date(currentDate),
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  formatForExport(array: any[]) {
    array.map((e) => {
      e.Technician = e.technician;
    });
  }

  async downloadExcel(finalData, fileName) {
    const columns = this.attendanceCols;
    const data = finalData;
    const downloadData = [];
    data.forEach((e: any) => {
      const d = {};
      columns.forEach((n: any) => (d[n.value] = e[n.value]));
      downloadData.push(d);
    });
    const serverTime:any = await this.httpService.getServerTime();
    const currentServerTime = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(serverTime), datetimeFormat.yyyymmddhhmm);
    this.exportService.JSONToCSVConvertor(downloadData, fileName, true,currentServerTime);
  }

  async onExport(isPrint?) {
    let hasOpenExportDialog: boolean = this.hasOpenExportDialog;
    const filter = this.helperService.deepCopy(this.filter);

    if (this.id === 'technician-attendance-log' && !(this.options.roType && this.reportType)) {
      if (this.filter.date.startDate) {
        this.getDaysInMonth(new Date(`${this.filter.date.startDate} 00:00`), new Date(`${this.filter.date.endDate} 23:59`));
        let fileName = 'technician-attendance-log';
        try {
          const data = await this.httpService.getAttendanceLogs({
            startDate: filter.date.startDate,
            endDate: filter.date.endDate,
            shopIds: filter.shopIds,
            totalHours: filter.clockedHours,
          });

          // first for all day map keys
          const finalData = data.records.map((record) => {
            const sheets = record.timesheetsPerDay || [];
            const formattedRecord = <any>{
              Technician: record.employee && record.employee.firstName ? `${record.employee.firstName} ${record.employee.lastName}` : '',
              [this.dateService.formatDate(new Date(`${this.filter.date.startDate}T00:00:00`), datetimeFormat.mmmyyyy)]: '',
              'Total Hours': record.totalHours ? `${record.totalHours.toFixed(2)}` : '',
            };

            // now move each day of month
            Object.keys(this.daysOfMonthMap).forEach((day: string) => {
              formattedRecord[`${day} ${this.daysNameMap[day]}`] = 0;
              // find this day in records
              sheets.forEach((dayCalculation) => {
                if (dayCalculation.dayOfMonth == day) {
                  formattedRecord[`${day} ${this.daysNameMap[day]}`] = this.calculationService.roundOff(dayCalculation.clockedHours);
                }
              });
            });

            return formattedRecord;
          });
          if (finalData && finalData.length > 0) {
            this.downloadExcel(finalData, fileName);
          }
        } catch (error) {
          this.helperService.showToaster('error', error);
        }

        return;
      }
    }
    this.formatFilterState.isPrint = isPrint;
    this.formatFilterState.id = this.id;
    // schedule business report
    if (this.hasSchedule && this.id !== 'royalty') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/print-view/business-report/`], {
          queryParams: {
            ...this.filter.date,
            shopIds: filter.shopIds,
            shopNames: this.companyLocations.map((location) => location.address),
            isNewBusinessSummary: this.dataService.isNewBusinessSummary,
            isSubletTrackingEnabled: this.isSubletTrackingEnabled,
            isPassThroughTaxEnable: this.dataService.isPassThroughTaxEnable,
            isRevenueRecognitionSettleEnabled: this.dataService.isRevenueRecognitionSettleEnabled,
          },
        }),
      );
      this.helperService.openPageInNewTab(url);
      return;
    }

    if ((this.id === 'breakdown-tax-report' || this.id === 'royalty') && isPrint) {
      hasOpenExportDialog = false;
    }

    if (hasOpenExportDialog) {
      if (this.drilldownItemType) this.data.drilldownItemType = this.drilldownItemType;
      if (this.dateType) this.data.isFinalize = this.dateType === 'Finalize Date' ? true : false;
      this.dialogService.open(ExportReportDialogComponent, {
        styleClass: 'add-dialog export-report-dialog',
        showHeader: false,
        data: {
          id: this.options.roType && this.reportType ? this.reportType : this.id,
          filter,
          searchQuery: this.searchQuery,
          data: this.data,
          selectedColumns: this.exportedColumns,
          formatFilterState: this.formatFilterState,
        },
      });
    } else if (this.id === 'royalty') {
      filter.dateType = this.dataService.dateType;
      const paramFilters = this.handleRoyaltyPrint(filter);
      let url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/royalty-report-print`], { queryParams: paramFilters }));
      this.helperService.openPageInNewTab(url);
    }
    // else if(this.id === 'items-enhance-item-sold-detail') {
    //   filter.dateType = this.dataService.dateType;
    //   const paramFilters = this.handleItemSoldReportPrint(filter);
    //   let url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/item-sold-details-report-print`], { queryParams: paramFilters }));
    //   this.helperService.openPageInNewTab(url);
    // }

    else {
      let url = '';
      if (this.id === 'breakdown-tax-report') {
        if (this.dataService.finalizeFilterBy) {
          filter.finalizationTypeList = JSON.stringify(this.dataService.finalizationTypeList);
        }
        const paramFilters = this.handleTaxSummaryItemsPrint(filter);
        url = this.router.serializeUrl(this.router.createUrlTree([`/print-view/tax-summary-item/`], { queryParams: paramFilters }));
      }
      this.helperService.openPageInNewTab(url);
    }
  }

  async onExportDrillDown() {
    this.formatFilterState.isPrint = false;
    this.data.drilldownItemType = this.drilldownItemTypeG;
    const filter = this.helperService.deepCopy(this.filter);
    filter.exportHybrid = true;
    filter.itemTypeDrillDown = this.itemType;
    if (this.dateType) this.data.isFinalize = this.dateType === 'Finalize Date' ? true : false;
    this.dialogService.open(ExportReportDialogComponent, {
      styleClass: 'add-dialog export-report-dialog',
      showHeader: false,
      data: {
        drilldown: true,
        id: this.options.roType && this.reportType ? this.reportType : this.id,
        filter,
        searchQuery: this.searchQuery,
        data: this.data,
        selectedColumns: this.exportedColumns,
        formatFilterState: this.formatFilterState,
      },
    });
  }

  async onExportXML() {
    const filter = this.helperService.deepCopy(this.filter);
    const { date = {} } = filter;
    const paramFilters: any = {
      shopIds: filter.shopIds,
      startDate: date.startDate,
      endDate: date.endDate,
    };

    if (this.dataService.finalizeFilterBy && this.dataService.isRevenueRecognitionSettleEnabled) {
      paramFilters.dateType = 'finalizeDate';
    } else {
      paramFilters.dateType = 'invoiceDate';
    }

    this.httpService.royaltyFeeXMLExport(paramFilters).then((res) => {
      console.log('XML file ', res);
      this.downloadXML(res);
    });
  }

  downloadXML(data) {
    const link = document.createElement('a');
    link.href = data;
    link.setAttribute('target', '_blank');
    link.setAttribute('download', 'AutoLeap-export.xml');
    link.setAttribute('type', 'application/xml');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleTaxSummaryItemsPrint(filter: any = {}) {
    const { date = {}, taxCode } = filter;
    let paramFilters: any = {};
    paramFilters = {
      shopsMap: JSON.stringify(this.dataService.shopsMap),
      isPreview: true,
      isFiltersApply: true,
      startDate: date.startDate,
      endDate: date.endDate,
      reportType: this.id,
      tableConfigTaxSummary: JSON.stringify(this.dataService.tableConfigTaxSummary),
      isSubletTrackingEnabled: this.isSubletTrackingEnabled,
      isPassThroughTaxEnable: this.isPassThroughTaxEnable,
      isCountTaxExemptROAsNonTaxedEnable: this.dataService.isCountTaxExemptROAsNonTaxedEnable,
      ...filter,
    };
    if (taxCode) {
      paramFilters.taxCode = JSON.stringify(taxCode);
    }
    if (this.dataService.baseTax) {
      paramFilters.baseTax = 'Accrual basis';
    } else {
      paramFilters.baseTax = 'Cash basis';
    }
    if (this.dataService.finalizeFilterBy) {
      paramFilters.finalizeFilterBy = 'Finalize date';
    } else {
      paramFilters.finalizeFilterBy = 'Invoice date';
    }
    return paramFilters;
  }

  handleRoyaltyPrint(filter: any = {}) {
    const { date = {} } = filter;
    let paramFilters: any = {};
    paramFilters = {
      shopsMap: JSON.stringify(this.dataService.shopsMap),
      isPreview: true,
      isFiltersApply: true,
      startDate: date.startDate,
      endDate: date.endDate,
      reportType: this.id,
      ...filter,
    };
    if (this.dataService.finalizeFilterBy && this.dataService.isRevenueRecognitionSettleEnabled) {
      paramFilters.finalizeFilterBy = 'Finalize date';
    } else {
      paramFilters.finalizeFilterBy = 'Invoice date';
    }
    return paramFilters;
  }

  handleItemSoldReportPrint(filter: any = {}) {
    const { date = {} } = filter;
    let paramFilters: any = {};
    paramFilters = {
      shopsMap: JSON.stringify(this.dataService.shopsMap),
      tableConfigItemSold: JSON.stringify(this.dataService.tableConfigItemSold),
      isPreview: true,
      isFiltersApply: true,
      startDate: date.startDate,
      endDate: date.endDate,
      reportType: this.id,
      ...filter,
    };
    if (this.dataService.finalizeFilterBy && this.dataService.isRevenueRecognitionSettleEnabled) {
      paramFilters.finalizeFilterBy = 'Finalize date';
    } else {
      paramFilters.finalizeFilterBy = 'Invoice date';
    }
    return paramFilters;
  }

  viewPrintLogs = () => {
    let type = '';
    if (this.id === printReportLabel.dailyPayment) type = 'dailyPaymentReport';
    if (this.id === printReportLabel.sales) type = 'salesReport';
    if (this.id === printReportLabel.taxSummaryItems) type = 'taxSummaryItemsReports';
    if (this.id === printReportLabel.royaltyReport) type = 'royaltyReport';

    this.dialogService.open(PrintLogDialogComponent, {
      styleClass: 'add-dialog print-log-dialog',
      showHeader: false,
      data: {
        type: type,
      },
    });
  };

  /**
   * Get filter keys
   */
  getFilterKeys(filterTypeKey: string): string[] {
    return Object.keys(this.filter[filterTypeKey]);
  }

  getSendFilterKeys(filterTypeKey: string): string[] {
    return Object.keys(this.filter[filterTypeKey]);
  }

  getPaidFilterKeys(filterTypeKey: string): string[] {
    return Object.keys(this.filter[filterTypeKey]);
  }

  /**
   * Check if qty type filter is applied
   */
  isQuantityFilterApplied(): boolean {
    return Object.keys(this.filter.qtyType).filter((key) => this.filter.qtyType[key]).length > 0;
  }

  /**
   * Check if send status filter is applied
   */
  isSendStatusFilterApplied(): boolean {
    return Object.keys(this.filter.sendStatus).filter((key) => this.filter.sendStatus[key]).length > 0;
  }

  /**
   * Check if paid status filter is applied
   */
  isPaidStatusFilterApplied(): boolean {
    return Object.keys(this.filter.paidStatus || {}).filter((key) => this.filter.paidStatus[key]).length > 0;
  }

  /**
   * Reset filters
   */
  resetQtyTypeFilters(): void {
    this.filterApplied.qtyType = false;


    if (!this.filter.qtyType) {
      this.filter.qtyType = {}; // Ensure it's an object before using Object.keys()
    }

    Object.keys(this.filter.qtyType).forEach((key) => {
      this.filter.qtyType[key] = false;
    });

  }

  /**
   * Reset filters
   */
  resetSentStatusFilters(): void {
    this.filterApplied.sendStatus = false;
    if (!this.filter.sendStatus) {
      this.filter.sendStatus = {}; // Ensure it's an object before using Object.keys()
    }
    Object.keys(this.filter.sendStatus).forEach((key) => {
      this.filter.sendStatus[key] = false;
    });
  }

  resetPaidStatusFilters(): void {
    this.dataService.paidStatus = '';
    this.filter.paidStatus = {
      paid: false,
      unPaid: false,
      partiallyPaid: false,
    };
  }

  /**
   * Get quantity type filter
   */
  getQuantityTypeTitle(): string {
    let title = '';
    Object.keys(this.filter.qtyType).forEach((key) => {
      if (this.filter.qtyType[key]) {
        // check if filter title already applied if yes that means multiple filters applied
        // set all in that case
        if (title) {
          title = this.filterTitle.qtyType.all;
        } else {
          title = this.filterTitle.qtyType[key];
        }
      }
    });

    // if no filter title at the end of loop that means no filter is applied
    if (!title) {
      title = this.filterTitle.qtyType.all;
    }
    return title;
  }

  /**
   * Get send status filter
   */
  getSendStatusTitle(): string {
    let title = '';
    Object.keys(this.filter.sendStatus).forEach((key) => {
      if (this.filter.sendStatus[key]) {
        // check if filter title already applied if yes that means multiple filters applied
        // set all in that case
        if (title) {
          title = this.filterTitle.sendStatus.all;
        } else {
          title = this.filterTitle.sendStatus[key];
        }
      }
    });

    // if no filter title at the end of loop that means no filter is applied
    if (!title) {
      title = this.filterTitle.sendStatus.all;
    }
    return title;
  }

  /**
   * Get paid status filter
   */
  getPaidStatusTitle(): string {
    let title = '';
    Object.keys(this.filter.paidStatus).forEach((key) => {
      if (this.filter.paidStatus[key]) {
        // check if filter title already applied if yes that means multiple filters applied
        // set all in that case
        if (title) {
          title = this.filterTitle.paidStatus.all;
        } else {
          title = this.filterTitle.paidStatus[key];
        }
      }
    });

    // if no filter title at the end of loop that means no filter is applied
    if (!title) {
      title = this.filterTitle.paidStatus.all;
    }
    return title;
  }

  onMultiLocationChange(shops: any[] = []): void {
    // this.filter.location.selected = [...shops];
    this.filter.location ??= {}; // Initialize `location` if undefined
    // this.filter.location.selected = [...shops]; // ALP-19607: No data is displaying under Inventory activity and Inventory level

    this.filter.shopIds = shops.map(({ _id }) => _id);
    this.filter.shopNames = shops.map(({ name }) => name);
    if (this.companyLocations.length === this.filter.shopIds.length || this.filter.shopIds.length === 1) {
      this.isDisableScheduleBtn = false;
    } else {
      this.isDisableScheduleBtn = true;
    }
    this.filterChange.emit(this.filter);
  }

  onSchedule() {
    const ref = this.dialogService.open(ReportScheduleComponent, {
      styleClass: `add-dialog report-schedule`,
      showHeader: false,
      data: {
        ...this.getModalDetails(),
        shopIds: this.filter.shopIds || [],
        isRoyaltyReport: this.path === '/reports/royalty'
      },
    });
    const onClose = ref.onClose.subscribe(() => {
      onClose.unsubscribe();
    });
  }

  getModalDetails() {
    if (this.id === 'royalty') {
      return {
        type: 'royaltyReport',
        title: `Schedule Royalty Report`,
        subTitle: `A PDF summary of this report will be sent at the end of every month to corporate and the emails entered below. The XML file will also be sent to corporate along with the PDF summary once scheduled.`,
      };
    }
    return {
      title: 'Schedule business summary report',
      subTitle: `Schedule a business summary report containing gross sales, collected receipts, account receivables, average income per order, detailed sales stats and labor stats. This summary will be sent
        out on a selected emails based on the schedule of your choice`,
      type: 'businessSummary',
    };
  }

  exportItemItem(itemType, isChecked) {
    // this.itemType = [];
    // if (isChecked) { this.itemType.push(itemType); }
    // else {
    //   this.itemType = this.itemType.filter(p => p !== itemType);
    // }
    this.itemType = itemType;
    this.drilldownItemTypeG = this.itemType;
    this.onExportDrillDown()
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }
}
